const books = [
  {
    key: 1,
    title: "The Great Gatsby",
    language: "English",
    pages: 180,
    category: "Fiction",
    price: 500,
    discount: 20,
    author: "F. Scott Fitzgerald",
    published_year: 1925,
    image_link:
      "https://m.media-amazon.com/images/I/817+192hZyS._AC_UY218_.jpg",
    about:
      " A tragic tale of wealth, love, and the American Dream set in 1920s America.",
  },
  {
    key: 2,
    title: "Pride and Prejudice",
    language: "English",
    pages: 320,
    category: "Fiction",
    price: 450,
    discount: 34,
    author: "Jane Austen",
    published_year: 1813,
    image_link:
      "https://m.media-amazon.com/images/I/819HSIKiWdS._AC_UY218_.jpg",
    about:
      "Classic romance novel exploring societal norms, love, and the complexities of relationships.",
  },
  {
    key: 3,
    title: "1984",
    language: "English",
    pages: 328,
    category: "Fiction",
    price: 400,
    discount: 20,
    author: "George Orwell",
    published_year: 1949,
    image_link:
      "https://m.media-amazon.com/images/I/81fcLJo+FNL._AC_UY218_.jpg",
    about:
      "A dystopian novel depicting a totalitarian regime's control over individual freedom and thought.",
  },
  {
    key: 4,
    title: "To Kill a Mockingbird",
    language: "English",
    pages: 281,
    category: "Fiction",
    price: 550,
    discount: 15,
    author: "Harper Lee",
    published_year: 1960,
    image_link:
      "https://m.media-amazon.com/images/I/81gepf1eMqL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A powerful story tackling racial injustice and moral growth through the eyes of a young girl.",
  },
  {
    key: 5,
    title: "The Catcher in the Rye",
    language: "English",
    pages: 224,
    category: "Fiction",
    price: 380,
    discount: 2,
    author: "J.D. Salinger",
    published_year: 1951,
    image_link:
      "https://m.media-amazon.com/images/I/7108sdEUEGL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "The introspective journey of a disillusioned teenager questioning society and its phoniness.",
  },
  {
    key: 6,
    title: "The Lord of the Rings",
    language: "English",
    pages: 1178,
    category: "Fantasy",
    price: 900,
    discount: 50,
    author: "J.R.R. Tolkien",
    published_year: 1954,
    image_link:
      "https://th.bing.com/th/id/OIP.0y0bOZvTsZfxQKrGSuQLrQHaJl?w=203&h=263&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Epic fantasy trilogy chronicling the quest to destroy a powerful ring and save Middle-earth.",
  },
  {
    key: 7,
    title: "Harry Potter and the Philosopher's Stone",
    language: "English",
    pages: 336,
    category: "Fantasy",
    price: 650,
    discount: 75,
    author: "J.K. Rowling",
    published_year: 1997,
    image_link:
      "https://th.bing.com/th/id/OIP.LbxkkFU9yseso-JyTL1k8QHaLI?w=203&h=306&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "The enchanting beginning of the Harry Potter series, introducing the world of magic and Hogwarts School.",
  },
  {
    key: 8,
    title: "The Alchemist",
    language: "English",
    pages: 208,
    category: "Fiction",
    price: 300,
    discount: 33,
    author: "Paulo Coelho",
    published_year: 1988,
    image_link:
      "https://th.bing.com/th/id/OIP.uztcFy4ysOQHIGz9yXZWYQHaKZ?w=203&h=286&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A philosophical allegorical novel exploring the journey of self-discovery and the pursuit of one's dreams.",
  },
  {
    key: 9,
    title: "The Hobbit",
    language: "English",
    pages: 304,
    category: "Fantasy",
    price: 750,
    discount: 37,
    author: "J.R.R. Tolkien",
    published_year: 1937,
    image_link:
      "https://th.bing.com/th/id/OIP.c2bx-a9mxm6DBYT9DXxpKQHaMN?w=194&h=320&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Bilbo Baggins embarks on an unexpected adventure with dwarves, encountering a dragon and the One Ring.",
  },
  {
    key: 10,
    title: "The Da Vinci Code",
    language: "English",
    pages: 689,
    category: "Mystery",
    price: 420,
    discount: 42,
    author: "Dan Brown",
    published_year: 2003,
    image_link:
      "https://th.bing.com/th/id/OIP.5W0ueGj2wV4LcpVtI6UYjQHaML?w=195&h=320&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " A gripping thriller uncovering religious conspiracies and secret societies with a symbologist at its core.",
  },
  {
    key: 11,
    title: "Moby-Dick",
    language: "English",
    pages: 720,
    category: "Fiction",
    price: 600,
    discount: 31,
    author: "Herman Melville",
    published_year: 1851,
    image_link:
      "https://th.bing.com/th/id/OIP.QH3OY_bFYzygHzW3f29ixgHaL0?w=197&h=315&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Captain Ahab's relentless pursuit of a legendary white whale becomes a metaphorical exploration of obsession and fate.",
  },
  {
    key: 12,
    title: "The Picture of Dorian Gray",
    language: "English",
    pages: 254,
    category: "Fiction",
    price: 420,
    discount: 36,
    author: "Oscar Wilde",
    published_year: 1890,
    image_link:
      "https://th.bing.com/th/id/OIP.jxtUxyB8J73Yt3vNW-MbhQHaLG?w=203&h=304&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Oscar Wilde's novel explores the corrupting influence of hedonism and the pursuit of eternal youth.",
  },
  {
    key: 13,
    title: "War and Peace",
    language: "English",
    pages: 1225,
    category: "Fiction",
    price: 950,
    discount: 77,
    author: "Leo Tolstoy",
    published_year: 1869,
    image_link:
      "https://th.bing.com/th/id/OIP.K_KlkYobnbhoifOrWKZvpAHaJ4?w=203&h=271&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Oscar Wilde's novel explores the corrupting influence of hedonism and the pursuit of eternal youth.",
  },
  {
    key: 14,
    title: "The Odyssey",
    language: "English",
    pages: 416,
    category: "Classics",
    price: 380,
    discount: 15,
    author: "Homer",
    published_year: -800,
    image_link:
      "https://th.bing.com/th/id/OIP.rBP4yzd2DqzYDkJcR8RkZgHaLc?w=201&h=310&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "The epic Greek poem chronicles Odysseus' journey home after the Trojan War, filled with mythical creatures and trials.",
  },
  {
    key: 15,
    title: "Brave New World",
    language: "English",
    pages: 288,
    category: "Fiction",
    price: 350,
    discount: 23,
    author: "Aldous Huxley",
    published_year: 1932,
    image_link:
      "https://th.bing.com/th/id/OIP.KuvNSFy4CIC9daYiNkvCWgHaMH?w=195&h=319&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A dystopian society's control over human reproduction, conditioning, and suppression of individuality.",
  },
  {
    key: 16,
    title: "The Divine Comedy",
    language: "English",
    pages: 798,
    category: "Classics",
    price: 750,
    discount: 29,
    author: "Dante Alighieri",
    published_year: 1320,
    image_link:
      "https://th.bing.com/th/id/OIP.scqspvH6r5kgJSZpF4o7XgAAAA?w=203&h=278&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " Dante's masterpiece takes readers on a journey through Hell, Purgatory, and Heaven, exploring moral and spiritual concepts.",
  },
  {
    key: 17,
    title: "Crime and Punishment",
    language: "English",
    pages: 430,
    category: "Fiction",
    price: 420,
    discount: 34,
    author: "Fyodor Dostoevsky",
    published_year: 1866,
    image_link:
      "https://th.bing.com/th/id/OIP.mfQ7vpAM4ic9GPyGw0CvaQHaLJ?w=203&h=306&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A psychological novel delving into the mind of a young murderer and his existential crisis.",
  },
  {
    key: 18,
    title: "Alice's Adventures in Wonderland",
    language: "English",
    pages: 200,
    category: "Children's",
    price: 250,
    discount: 61,
    author: "Lewis Carroll",
    published_year: 1865,
    image_link:
      "https://th.bing.com/th/id/OIP.PJjQQhoKlFiWgBQMVBT_JgHaJU?w=203&h=256&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Lewis Carroll's whimsical tale follows Alice's encounters with peculiar characters in a nonsensical world.",
  },
  {
    key: 19,
    title: "The Little Prince",
    language: "English",
    pages: 96,
    category: "Children's",
    price: 200,
    discount: 45,
    author: "Antoine de Saint-Exupéry",
    published_year: 1943,
    image_link:
      "https://th.bing.com/th/id/OIP.NXy__tPr2YhXWRZV6mv24QHaK6?w=203&h=300&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Lewis Carroll's whimsical tale follows Alice's encounters with peculiar characters in a nonsensical world.",
  },
  {
    key: 20,
    title: "The Adventures of Tom Sawyer",
    language: "English",
    pages: 224,
    category: "Fiction",
    price: 320,
    discount: 30,
    author: "Mark Twain",
    published_year: 1876,
    image_link:
      "https://th.bing.com/th/id/OIP.oWw4f5Nlg2i0ZSjJGvlAigHaLH?w=203&h=304&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Mark Twain's classic captures the mischievous escapades of a young boy in a small American town.",
  },
  {
    key: 21,
    title: "The Kite Runner",
    language: "English",
    pages: 371,
    category: "Fiction",
    price: 420,
    discount: 37,
    author: "Khaled Hosseini",
    published_year: 2003,
    image_link:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/regionalbooks/4/e/v/the-kite-runner-original-imagqjrzgaqhmwrr.jpeg?q=70",
    about:
      " A story of friendship and redemption set against the backdrop of Afghanistan's tumultuous history.",
  },
  {
    key: 22,
    title: "The Chronicles of Narnia",
    language: "English",
    pages: 767,
    category: "Fantasy",
    price: 780,
    discount: 48,
    author: "C.S. Lewis",
    published_year: 1950,
    image_link:
      "https://th.bing.com/th/id/OIP.sZjOXDf3pI6NhK5FKEuQWwHaLH?w=203&h=304&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " A beloved series following children's adventures in the magical world of Narnia, filled with talking animals and epic battles.",
  },
  {
    key: 23,
    title: "A Tale of Two Cities",
    language: "English",
    pages: 448,
    category: "Fiction",
    price: 380,
    discount: 65,
    author: "Charles Dickens",
    published_year: 1859,
    image_link:
      "https://th.bing.com/th/id/OIP.OaXhenZHK0nrAmep1zu_HQHaKf?w=203&h=287&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Set during the French Revolution, it explores love, sacrifice, and the turmoil of two cities.",
  },
  {
    key: 24,
    title: "The Fault in Our Stars",
    language: "English",
    pages: 313,
    category: "Young Adult",
    price: 350,
    discount: 32,
    author: "John Green",
    published_year: 2012,
    image_link:
      "https://th.bing.com/th/id/OIP.Puz7uOjwHPpm5qOCe8QG6QHaIq?w=203&h=237&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A heart-wrenching young adult novel about two cancer-stricken teenagers who find love and meaning in life's imperfections.",
  },
  {
    key: 25,
    title: "The Hunger Games",
    language: "English",
    pages: 374,
    category: "Young Adult",
    price: 410,
    discount: 68,
    author: "Suzanne Collins",
    published_year: 2008,
    image_link:
      "https://th.bing.com/th/id/OIP.nLIHNwrATDdgiQSjeuOvmQHaLI?w=203&h=306&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A thrilling dystopian novel where teenagers fight for survival in a televised event.",
  },
  {
    key: 26,
    title: "A Game of Thrones",
    language: "English",
    pages: 694,
    category: "Fantasy",
    price: 590,
    discount: 42,
    author: "George R.R. Martin",
    published_year: 1996,
    image_link:
      "https://th.bing.com/th/id/OIP.d5v5ixXYHSuxDmcciVnhggHaLT?w=202&h=308&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A complex fantasy epic filled with political intrigue, power struggles, and a battle for the Iron Throne.",
  },
  {
    key: 27,
    title: "The Book Thief",
    language: "English",
    pages: 576,
    category: "Historical Fiction",
    price: 450,
    discount: 7,
    author: "Markus Zusak",
    published_year: 2005,
    image_link:
      "https://th.bing.com/th/id/OIP.QXfpwLb6of2QlgHwviXxogHaLj?w=200&h=312&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Set during World War II, this story follows a young girl who steals books and finds solace in their pages.",
  },
  {
    key: 28,
    title: "Gone with the Wind",
    language: "English",
    pages: 1037,
    category: "Historical Fiction",
    price: 850,
    discount: 11,
    author: "Margaret Mitchell",
    published_year: 1936,
    image_link:
      "https://th.bing.com/th/id/OIP.lWJbIITikXfn5wpsJGMoIAHaK6?w=203&h=300&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A sweeping historical romance set during the American Civil War, exploring love, loss, and resilience.",
  },
  {
    key: 29,
    title: "The Secret Garden",
    language: "English",
    pages: 331,
    category: "Children's",
    price: 320,
    discount: 44,
    author: "Frances Hodgson Burnett",
    published_year: 1911,
    image_link:
      "https://th.bing.com/th/id/OIP.0a-YluqJaTtbVkPnCe7rUQHaJd?w=203&h=259&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A heartwarming tale of a young girl who discovers a hidden garden and its transformative power.",
  },
  {
    key: 30,
    title: "The Shining",
    language: "English",
    pages: 659,
    category: "Horror",
    price: 420,
    discount: 35,
    author: "Stephen King",
    published_year: 1977,
    image_link:
      "https://th.bing.com/th/id/OIP.CYblMPVZMKRQWC_M3sICbAHaLa?w=201&h=310&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A terrifying psychological horror novel about a family's descent into madness at an isolated hotel.",
  },
  {
    key: 31,
    title: "The Girl with the Dragon Tattoo",
    language: "English",
    pages: 590,
    category: "Mystery",
    price: 450,
    discount: 37,
    author: "Stieg Larsson",
    published_year: 2005,
    image_link:
      "https://th.bing.com/th/id/OIP.Syq6bSLJ8w8PkZDI6t5JlwHaLh?w=200&h=311&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A gripping mystery featuring a unique and enigmatic protagonist, Lisbeth Salander.",
  },
  {
    key: 32,
    title: "The Count of Monte Cristo",
    language: "English",
    pages: 1276,
    category: "Classics",
    price: 750,
    discount: 30,
    author: "Alexandre Dumas",
    published_year: 1844,
    image_link:
      "https://th.bing.com/th/id/OIP.qsvDJqMdQ0iKsanqQ7j8JAHaML?w=194&h=320&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      " A classic tale of revenge, betrayal, and redemption as a man seeks vengeance against those who wronged him.",
  },
  {
    key: 33,
    title: "The Help",
    language: "English",
    pages: 544,
    category: "Historical Fiction",
    price: 420,
    discount: 43,
    author: "Kathryn Stockett",
    published_year: 2009,
    image_link:
      "https://th.bing.com/th/id/OIP.GVoXTzI9RzSvcOmSA3EJZAHaMH?w=194&h=318&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Set in 1960s Mississippi, this novel explores racial tensions and the relationships between black maids and their white employers.",
  },
  {
    key: 34,
    title: "The Adventures of Huckleberry Finn",
    language: "English",
    pages: 366,
    category: "Fiction",
    price: 380,
    discount: 17,
    author: "Mark Twain",
    published_year: 1884,
    image_link:
      "https://th.bing.com/th/id/OIP.k--w3KXyH0vqdW-v5gsFgAHaLb?w=201&h=310&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "Mark Twain's iconic coming-of-age story follows Huck Finn and Jim, an escaped slave, as they navigate the Mississippi River.",
  },
  {
    key: 35,
    title: "Slaughterhouse-Five",
    language: "English",
    pages: 275,
    category: "Science Fiction",
    price: 350,
    discount: 13,
    author: "Kurt Vonnegut",
    published_year: 1969,
    image_link:
      "https://th.bing.com/th/id/OIP.zqkhFZJEv9xqwMQN4aTjogHaLQ?w=202&h=308&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A satirical and thought-provoking science fiction novel that explores the concept of time and the horrors of war.",
  },
  {
    key: 36,
    title: "The Giver",
    language: "English",
    pages: 240,
    category: "Young Adult",
    price: 320,
    discount: 2,
    author: "Lois Lowry",
    published_year: 1993,
    image_link:
      "https://th.bing.com/th/id/OIP.UJhqgEqd_MOA8QeNxlTJvgHaML?w=194&h=320&c=7&r=0&o=5&dpr=1.5&pid=1.7,",
    about:
      "A dystopian novel where a young boy discovers the truth about his seemingly perfect but emotionless society.",
  },
  {
    title: "The God of Small Things",
    key: 37,
    language: "English",
    pages: 336,
    category: "Stories",
    price: 399,
    discount: 10,
    author: "Arundhati Roy",
    published_year: 1997,
    image_link: "https://m.media-amazon.com/images/I/91saO95VziL._SY522_.jpg",
    about: "A story of love, family, and societal constraints set in Kerala.",
  },
  {
    key: 38,
    title: "The 5 Love Languages: The Secret to Love That Lasts",
    language: "English",
    pages: 208,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Gary Chapman",
    published_year: 1992,
    image_link:
      "https://m.media-amazon.com/images/I/51c0ewv4OML._AC_UY218_.jpg",
    about:
      "Discusses the different ways people give and receive love and how to strengthen relationships.",
  },
  {
    title: "अल्बेला रहीम",
    key: 39,
    language: "Hindi",
    pages: 180,
    category: "Stories",
    price: 299,
    discount: 15,
    author: "श्रीलाल शुक्ल",
    published_year: 1988,
    image_link:
      "https://th.bing.com/th/id/OIP.-kglyYQ1_z1pT3doVF2yPAAAAA?w=203&h=270&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "An exploration of the life and adventures of Rahim, a charismatic character.",
  },
  {
    title: "The Guide",
    key: 40,
    language: "English",
    pages: 320,
    category: "Stories",
    price: 449,
    discount: 12,
    author: "R.K. Narayan",
    published_year: 1958,
    image_link:
      "https://m.media-amazon.com/images/I/71m4x4wunyL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "The story of a tour guide's journey and his transformational experiences.",
  },

  {
    title: "पंचांगुली की कहानियाँ",
    key: 42,
    language: "Hindi",
    pages: 240,
    category: "Stories",
    price: 299,
    discount: 10,
    author: "फणीश्वर नाथ रेणू",
    published_year: 1995,
    image_link:
      "https://th.bing.com/th/id/OIP.d3kmQeCfEnYQFKrAdcHlGwAAAA?w=203&h=270&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A collection of thought-provoking stories by renowned author Fani Nath Renu.",
  },
  {
    title: "A Suitable Boy",
    key: 43,
    language: "English",
    pages: 1474,
    category: "Stories",
    price: 599,
    discount: 20,
    author: "Vikram Seth",
    published_year: 1993,
    image_link:
      "https://m.media-amazon.com/images/I/51lTMZ6-txL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A sweeping tale of love, family, and politics set in post-independence India.",
  },
  {
    key: 44,
    title:
      "The Gifts of Imperfection: Let Go of Who You Think You're Supposed to Be and Embrace Who You Are",
    language: "English",
    pages: 160,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Brené Brown",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/71aHmBv498L._AC_UY218_.jpg",
    about:
      "Explores the power of embracing imperfections and living wholeheartedly.",
  },
  {
    title: "स्वामी विवेकानंद जीवनी",
    key: 45,
    language: "Hindi",
    pages: 280,
    category: "Biography",
    price: 399,
    discount: 10,
    author: "स्वामी विवेकानंद",
    published_year: 1896,
    image_link:
      "https://m.media-amazon.com/images/I/71Z8ZDGp9HL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive biography of Swami Vivekananda, the great Indian philosopher and spiritual leader.",
  },
  {
    title: "The White Tiger",
    key: 46,
    language: "English",
    pages: 304,
    category: "Fiction",
    price: 299,
    discount: 15,
    author: "Aravind Adiga",
    published_year: 2008,
    image_link:
      "https://m.media-amazon.com/images/I/91EIu4XjsvL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A darkly humorous and thought-provoking novel that explores class struggle and corruption in modern India.",
  },
  {
    key: 47,
    title: "Infinite Possibilities: The Art of Living Your Dreams",
    language: "English",
    pages: 304,
    category: "Health",
    price: 1250,
    discount: 15,
    rating: 4.7,
    author: "Mike Dooley",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/51asxtcYh+L._AC_UY218_.jpg",
    about:
      "Explores the power of thoughts and beliefs in shaping our reality and achieving our dreams.",
  },
  {
    title: "मृत्युंजय",
    key: 48,
    language: "Hindi",
    pages: 600,
    category: "Historical Fiction",
    price: 499,
    discount: 5,
    author: "शिवाजी सावंत",
    published_year: 1967,
    image_link:
      "https://m.media-amazon.com/images/I/81T8JapGcVL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A captivating retelling of the life of Karna, a central character from the Mahabharata.",
  },
  {
    title: "The Immortals of Meluha",
    key: 49,
    language: "English",
    pages: 436,
    category: "Fantasy",
    price: 349,
    discount: 20,
    author: "Amish Tripathi",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/818bGgNn0EL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "The first book in the Shiva Trilogy series, blending mythology and fantasy in a gripping narrative.",
  },
  {
    key: 50,
    title: "The Alchemist",
    language: "English",
    pages: 208,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Paulo Coelho",
    published_year: 1988,
    image_link:
      "https://m.media-amazon.com/images/I/51bVNTqHFlL._AC_UY218_.jpg",
    about:
      "Follows the journey of a young shepherd seeking his personal legend and the meaning of life.",
  },
  {
    title: "The Secret of the Nagas",
    key: 51,
    language: "English",
    pages: 396,
    category: "Fantasy",
    price: 399,
    discount: 10,
    author: "Amish Tripathi",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/81R5xrntmdL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "The second book in the Shiva Trilogy series, delving deeper into the mysteries of the ancient Nagas.",
  },
  {
    key: 52,
    title: "The Whole30: The 30-Day Guide to Total Health and Food Freedom",
    language: "English",
    pages: 432,
    category: "Health",
    price: 1150,
    discount: 10,
    rating: 4.6,
    author: "Melissa Hartwig Urban",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/81zu4Bcly6L._AC_UY218_.jpg",
    about:
      "Provides a 30-day dietary program to reset your body and improve overall health.",
  },
  {
    title: "इतिहास के स्वर्णिम पन्नों",
    key: 53,
    language: "Hindi",
    pages: 384,
    category: "History",
    price: 299,
    discount: 15,
    author: "कमलेश्वर",
    published_year: 2003,
    image_link:
      "https://th.bing.com/th/id/OIP.e7usuGKt6KqUZ2bnTkAMwwAAAA?w=134&h=184&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about:
      "A comprehensive history book highlighting significant events and personalities from India's past.",
  },
  {
    title: "The Oath of the Vayuputras",
    key: 54,
    language: "English",
    pages: 575,
    category: "Fantasy",
    price: 449,
    discount: 10,
    author: "Amish Tripathi",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/81vZCuRX6-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "The final book in the Shiva Trilogy series, concluding the epic adventure of Lord Shiva.",
  },
  {
    key: 55,
    title: "The Four Agreements: A Practical Guide to Personal Freedom",
    language: "English",
    pages: 160,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Don Miguel Ruiz",
    published_year: 1997,
    image_link:
      "https://m.media-amazon.com/images/I/81hHy5XrdKL._AC_UY218_.jpg",
    about:
      "Presents four principles for personal transformation and happiness based on ancient Toltec wisdom.",
  },
  {
    title: "श्रीमान योगी",
    key: 56,
    language: "Hindi",
    pages: 512,
    category: "Biography",
    price: 399,
    discount: 10,
    author: "रवींद्र नाथ त्रिपाठी",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/51FnFhekNsL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive biography of Yogi Adityanath, the current Chief Minister of Uttar Pradesh.",
  },
  {
    key: 57,
    title: "The Alchemist",
    language: "English",
    pages: 208,
    category: "General Knowledge",
    price: 250,
    discount: 10,
    author: "Paulo Coelho",
    published_year: 1988,
    image_link:
      "https://m.media-amazon.com/images/I/51bVNTqHFlL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A philosophical novel about a young shepherd seeking his destiny.",
  },
  {
    key: 58,
    title: "Atomic Habits",
    language: "English",
    pages: 320,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.8,
    author: "James Clear",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/61gJ4hWIwrL._AC_UY218_.jpg",
    about:
      "Offers practical strategies to create and maintain positive habits in life and work.",
  },
  {
    key: 59,
    title: "Godan",
    language: "Hindi",
    pages: 400,
    category: "General Knowledge",
    price: 320,
    discount: 5,
    author: "Munshi Premchand",
    published_year: 1936,
    image_link:
      "https://m.media-amazon.com/images/I/41OKM0TqBPL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A Hindi novel depicting the struggles of a poor farmer.",
  },
  {
    key: 60,
    title: "The Guide",
    language: "English",
    pages: 352,
    category: "General Knowledge",
    price: 275,
    discount: 20,
    author: "R.K. Narayan",
    published_year: 1958,
    image_link:
      "https://m.media-amazon.com/images/I/71m4x4wunyL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A classic English novel set in rural India, exploring human desires and aspirations.",
  },
  {
    key: 61,
    title: "The 5 AM Club: Own Your Morning. Elevate Your Life.",
    language: "English",
    pages: 336,
    category: "Health",
    price: 1250,
    discount: 10,
    rating: 4.7,
    author: "Robin Sharma",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/41lhTyHPIrL._AC_UY218_.jpg",
    about:
      "Provides a morning routine and productivity strategies to optimize personal and professional success.",
  },
  {
    key: 62,
    title: "The Discovery of India",
    language: "English",
    pages: 720,
    category: "General Knowledge",
    price: 450,
    discount: 15,
    author: "Jawaharlal Nehru",
    published_year: 1946,
    image_link:
      "https://m.media-amazon.com/images/I/61zZzKlLleL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive account of Indian history, culture, and philosophy by the first Prime Minister of India.",
  },
  {
    key: 63,
    title:
      "Eat, Pray, Love: One Woman's Search for Everything Across Italy, India, and Indonesia",
    language: "English",
    pages: 352,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Elizabeth Gilbert",
    published_year: 2006,
    image_link:
      "https://m.media-amazon.com/images/I/81IHVj5+OvL._AC_UY218_.jpg",
    about:
      "Memoir of a woman's journey to find herself through travel and self-discovery.",
  },
  {
    key: 64,
    title: "Saraswatichandra",
    language: "Gujarati",
    pages: 848,
    category: "General Knowledge",
    price: 380,
    discount: 8,
    author: "Govardhanram Madhavram Tripathi",
    published_year: 1887,
    image_link:
      "https://m.media-amazon.com/images/I/61vIfbKUWzL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An acclaimed Gujarati novel depicting the intertwined lives of its characters.",
  },
  {
    key: 65,
    title: "Rich Dad Poor Dad",
    language: "English",
    pages: 336,
    category: "Financial Education",
    price: 299,
    discount: 10,
    rating: 4.5,
    author: "Robert T. Kiyosaki",
    published_year: 1997,
    image_link:
      "https://m.media-amazon.com/images/I/81BE7eeKzAL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A personal finance book that discusses the mindset and strategies for building wealth.",
  },
  {
    key: 66,
    title: "The Plant Paradox",
    language: "English",
    pages: 416,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Steven R. Gundry",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/81iruZ3hvuL._AC_UY218_.jpg",
    about:
      "Challenges conventional wisdom on healthy eating and discusses the impact of certain plant-based foods.",
  },
  {
    key: 67,
    title: "The Intelligent Investor",
    language: "English",
    pages: 640,
    category: "Financial Education",
    price: 599,
    discount: 5,
    rating: 4.7,
    author: "Benjamin Graham",
    published_year: 1949,
    image_link:
      "https://m.media-amazon.com/images/I/41nBryq6OcL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A classic book on value investing and fundamental analysis of stocks.",
  },
  {
    key: 68,
    title: "मेरा बचपन दुबारा",
    language: "Hindi",
    pages: 256,
    category: "Financial Education",
    price: 179,
    discount: 12,
    rating: 4.3,
    author: "मोनिका हलदार (Monika Halder)",
    published_year: 2018,
    image_link:
      "https://th.bing.com/th/id/OIP.wUbRQulVirAIm961idlCXgHaNK?w=115&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7",
    about: "व्यक्तिगत वित्त और आर्थिक स्वतंत्रता के बारे में हिंदी आत्मकथा।",
  },
  {
    key: 69,
    title: "The Little Book of Common Sense Investing",
    language: "English",
    pages: 304,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "John C. Bogle",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/51wvE48u69L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A guide to low-cost index investing and building a successful investment portfolio.",
  },
  {
    key: 70,
    title: "The Language of Medicine",
    language: "English",
    pages: 1056,
    category: "Health",
    price: 1550,
    discount: 20,
    rating: 4.7,
    author: "Davi-Ellen Chabner",
    published_year: 1981,
    image_link:
      "https://m.media-amazon.com/images/I/81KRjYXj9QL._AC_UY218_.jpg",
    about:
      "Comprehensive guide to medical terminology for healthcare professionals and students.",
  },
  {
    key: 71,
    title: "Think and Grow Rich",
    language: "English",
    pages: 238,
    category: "Financial Education",
    price: 249,
    discount: 10,
    rating: 4.4,
    author: "Napoleon Hill",
    published_year: 1937,
    image_link:
      "https://m.media-amazon.com/images/I/711xMzVPIuL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A classic self-help book that explores the principles of success and wealth creation.",
  },
  {
    key: 72,
    title:
      "Medical Medium: Secrets Behind Chronic and Mystery Illness and How to Finally Heal",
    language: "English",
    pages: 392,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Anthony William",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/81x+tKRek1L._AC_UY218_.jpg",
    about:
      "Presents information on the root causes of chronic illnesses and natural healing approaches.",
  },
  {
    key: 73,
    title: "The Millionaire Next Door",
    language: "English",
    pages: 272,
    category: "Financial Education",
    price: 349,
    discount: 5,
    rating: 4.7,
    author: "Thomas J. Stanley, William D. Danko",
    published_year: 1996,
    image_link:
      "https://m.media-amazon.com/images/I/71Bn7xvq5JL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An examination of the common traits and habits of America's wealthy individuals.",
  },

  // cdc GAP 74 TO 83
  {
    key: 75,
    title: "The Immortal Life of Henrietta Lacks",
    language: "English",
    pages: 381,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Rebecca Skloot",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/91Xsy7U27RL._AC_UY218_.jpg",
    about:
      "Explores the story of Henrietta Lacks and her contribution to medical science.",
  },
  {
    key: 76,
    title: "How Not to Die",
    language: "English",
    pages: 576,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Michael Greger, Gene Stone",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/71uMo7MfIfL._AC_UY218_.jpg",
    about:
      "Discusses evidence-based approaches to prevent and reverse chronic diseases.",
  },
  {
    key: 77,
    title: "Being Mortal: Medicine and What Matters in the End",
    language: "English",
    pages: 282,
    category: "Health",
    price: 1050,
    discount: 10,
    rating: 4.8,
    author: "Atul Gawande",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/81DeqWKI0PL._AC_UY218_.jpg",
    about:
      "Examines the challenges and choices faced by terminally ill patients and their families.",
  },
  {
    key: 78,
    title: "The Gene: An Intimate History",
    language: "English",
    pages: 608,
    category: "Health",
    price: 1550,
    discount: 20,
    rating: 4.7,
    author: "Siddhartha Mukherjee",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/81j9Yk7PycL._AC_UY218_.jpg",
    about:
      "Explores the history and impact of genetics on human life and society.",
  },
  {
    key: 79,
    title: "Educated: A Memoir",
    language: "English",
    pages: 400,
    category: "Health",
    price: 1250,
    discount: 10,
    rating: 4.8,
    author: "Tara Westover",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/41cBfYtG-YL._AC_UY218_.jpg",
    about:
      "Memoir of a woman who escapes her isolated and abusive childhood through education.",
  },
  {
    key: 80,
    title: "The Emperor of All Maladies: A Biography of Cancer",
    language: "English",
    pages: 592,
    category: "Health",
    price: 1450,
    discount: 10,
    rating: 4.7,
    author: "Siddhartha Mukherjee",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/71sylz8QEaL._AC_UY218_.jpg",
    about: "Traces the history of cancer research and treatment.",
  },
  {
    key: 81,
    title: "Sapiens: A Brief History of Humankind",
    language: "English",
    pages: 512,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Yuval Noah Harari",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/713jIoMO3UL._AC_UY218_.jpg",
    about: "Explores the history and impact of Homo sapiens on the world.",
  },
  {
    key: 82,
    title: "The Body: A Guide for Occupants",
    language: "English",
    pages: 464,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Bill Bryson",
    published_year: 2019,
    image_link:
      "https://m.media-amazon.com/images/I/81s7TIR+8SL._AC_UY218_.jpg",
    about:
      "Takes readers on a tour of the human body and its complex workings.",
  },
  {
    key: 83,
    title: "When Breath Becomes Air",
    language: "English",
    pages: 256,
    category: "Health",
    price: 1050,
    discount: 10,
    rating: 4.8,
    author: "Paul Kalanithi",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71iw3KvoQiL._AC_UY218_.jpg",
    about: "Memoir of a neurosurgeon facing a terminal lung cancer diagnosis.",
  },
  {
    key: 84,
    title: "The Power of Now: A Guide to Spiritual Enlightenment",
    language: "English",
    pages: 236,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Eckhart Tolle",
    published_year: 1997,
    image_link:
      "https://m.media-amazon.com/images/I/4142GCKCZGL._AC_UY218_.jpg",
    about:
      "Explores the concept of mindfulness and living in the present moment.",
  },

  {
    key: 85,
    title: "Stiff: The Curious Lives of Human Cadavers",
    language: "English",
    pages: 320,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Mary Roach",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/71Bl7sCyC+L._AC_UY218_.jpg",
    about:
      "Explores the various scientific uses of human cadavers and their impact on society.",
  },
  {
    key: 86,
    title: "The Psychology of Money",
    language: "English",
    pages: 256,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "Morgan Housel",
    published_year: 2020,
    image_link:
      "https://m.media-amazon.com/images/I/41r6F2LRf8L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An exploration of the psychological and behavioral aspects of money management and financial decisions.",
  },
  {
    key: 87,
    title: "The Four Hour Workweek",
    language: "English",
    pages: 416,
    category: "Financial Education",
    price: 449,
    discount: 10,
    rating: 4.3,
    author: "Timothy Ferriss",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/71DPD5QEZCL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A guide to escaping the 9-5 grind and designing your ideal lifestyle through entrepreneurship and passive income.",
  },
  {
    key: 88,
    title:
      "The Miracle Morning: The Not-So-Obvious Secret Guaranteed to Transform Your Life",
    language: "English",
    pages: 180,
    category: "Health",
    price: 850,
    discount: 10,
    rating: 4.7,
    author: "Hal Elrod",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/61R1UgGxaLL._AC_UY218_.jpg",
    about:
      "Offers a morning routine to enhance personal development and productivity.",
  },
  {
    key: 89,
    title: "The Richest Man in Babylon",
    language: "English",
    pages: 194,
    category: "Financial Education",
    price: 249,
    discount: 10,
    rating: 4.5,
    author: "George S. Clason",
    published_year: 1926,
    image_link:
      "https://m.media-amazon.com/images/I/81NYuWzsJcS._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A collection of parables set in ancient Babylon, providing timeless lessons on personal finance and wealth creation.",
  },
  {
    key: 90,
    title: "The Checklist Manifesto: How to Get Things Right",
    language: "English",
    pages: 240,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Atul Gawande",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/51I4r8W6auL._AC_UY218_.jpg",
    about:
      "Advocates for the use of checklists to improve safety and efficiency in various fields.",
  },
  {
    key: 91,
    title: "The Bogleheads' Guide to Investing",
    language: "English",
    pages: 336,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "Taylor Larimore, Mel Lindauer, Michael LeBoeuf",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/71nLAPB7ExL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive guide to passive investing and achieving financial success based on the principles of John C. Bogle.",
  },
  {
    key: 92,
    title: "Man's Search for Meaning",
    language: "English",
    pages: 184,
    category: "Health",
    price: 850,
    discount: 10,
    rating: 4.7,
    author: "Viktor E. Frankl",
    published_year: 1946,
    image_link:
      "https://m.media-amazon.com/images/I/61nTspM+BYL._AC_UY218_.jpg",
    about:
      "Memoir of Viktor Frankl's experiences in Nazi concentration camps and his psychological insights.",
  },
  {
    key: 93,
    title: "The Total Money Makeover",
    language: "English",
    pages: 272,
    category: "Financial Education",
    price: 349,
    discount: 5,
    rating: 4.7,
    author: "Dave Ramsey",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/81LggRYMq6L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A step-by-step guide to achieving financial freedom and managing money effectively.",
  },
  {
    key: 94,
    title: "Quiet: The Power of Introverts in a World That Can't Stop Talking",
    language: "English",
    pages: 368,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "Susan Cain",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/71OuZbXcITL._AC_UY218_.jpg",
    about:
      "Explores the strengths and challenges of introverts in a society that values extroversion.",
  },
  {
    key: 95,
    title: "I Will Teach You to Be Rich",
    language: "English",
    pages: 352,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "Ramit Sethi",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/81c9SSbG3OL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A practical guide to personal finance and wealth-building strategies for young adults.",
  },
  {
    key: 96,
    title: "In Defense of Food: An Eater's Manifesto",
    language: "English",
    pages: 256,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Michael Pollan",
    published_year: 2008,
    image_link:
      "https://m.media-amazon.com/images/I/81Qf08BANML._AC_UY218_.jpg",
    about:
      "Examines the impact of the Western diet on health and offers guidelines for healthy eating.",
  },
  {
    key: 97,
    title: "The Alchemist",
    language: "English",
    pages: 208,
    category: "Financial Education",
    price: 249,
    discount: 10,
    rating: 4.4,
    author: "Paulo Coelho",
    published_year: 1988,
    image_link:
      "https://m.media-amazon.com/images/I/51bVNTqHFlL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A philosophical novel that follows a young Andalusian shepherd on his journey to find a hidden treasure.",
  },
  {
    key: 98,
    title: "Brain on Fire: My Month of Madness",
    language: "English",
    pages: 288,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Susannah Cahalan",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/718FHaPBJ-L._AC_UY218_.jpg",
    about:
      "Memoir of a young woman's struggle with a rare autoimmune disease affecting her brain.",
  },
  {
    key: 99,
    title: "The Lean Startup",
    language: "English",
    pages: 336,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.5,
    author: "Eric Ries",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/81vvgZqCskL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A guide to building successful startups through the application of lean management and agile development principles.",
  },
  {
    key: 100,
    title: "The Hidden Life of Trees: What They Feel, How They Communicate",
    language: "English",
    pages: 288,
    category: "Health",
    price: 1150,
    discount: 10,
    rating: 4.6,
    author: "Peter Wohlleben",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/71GDD7r3hML._AC_UY218_.jpg",
    about:
      "Explores the fascinating world of trees and their interconnectedness.",
  },
  {
    key: 101,
    title: "The Power of Habit",
    language: "English",
    pages: 400,
    category: "Financial Education",
    price: 449,
    discount: 10,
    rating: 4.6,
    author: "Charles Duhigg",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/71ONWR6eXDL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An exploration of the science behind habits and how they can be changed to improve personal and professional life.",
  },
  {
    key: 102,
    title:
      "The Whole-Brain Child: 12 Revolutionary Strategies to Nurture Your Child's Developing Mind",
    language: "English",
    pages: 192,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Daniel J. Siegel, Tina Payne Bryson",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/71uBu36s7SL._AC_UY218_.jpg",
    about:
      "Provides strategies for parents to promote healthy brain development in children.",
  },
  {
    key: 103,
    title: "Sapiens: A Brief History of Humankind",
    language: "English",
    pages: 498,
    category: "Financial Education",
    price: 499,
    discount: 5,
    rating: 4.7,
    author: "Yuval Noah Harari",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/713jIoMO3UL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A thought-provoking book that explores the history and impact of Homo sapiens on the world.",
  },
  {
    key: 104,
    title:
      "The Body Keeps the Score: Brain, Mind, and Body in the Healing of Trauma",
    language: "English",
    pages: 464,
    category: "Health",
    price: 1250,
    discount: 10,
    rating: 4.8,
    author: "Bessel van der Kolk",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/71-OnTj8N8L._AC_UY218_.jpg",
    about:
      "Explores the impact of trauma on the body and offers insights on healing.",
  },
  {
    key: 105,
    title: "The 7 Habits of Highly Effective People",
    language: "English",
    pages: 432,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "Stephen R. Covey",
    published_year: 1989,
    image_link:
      "https://m.media-amazon.com/images/I/81tSGmrwCFL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A self-help book that presents a holistic approach to personal and professional effectiveness.",
  },
  {
    key: 106,
    title: "Salt, Sugar, Fat: How the Food Giants Hooked Us",
    language: "English",
    pages: 480,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Michael Moss",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/81SBuBC7XKL._AC_UY218_.jpg",
    about:
      "Investigates the tactics used by food companies to make their products addictive.",
  },
  {
    key: 107,
    title: "Think Like a Monk",
    language: "English",
    pages: 352,
    category: "Financial Education",
    price: 449,
    discount: 10,
    rating: 4.5,
    author: "Jay Shetty",
    published_year: 2020,
    image_link:
      "https://m.media-amazon.com/images/I/71GBwRkvchL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A guide to finding purpose, peace, and happiness through mindfulness and ancient wisdom.",
  },
  {
    key: 108,
    title: "Becoming",
    language: "English",
    pages: 448,
    category: "Health",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Michelle Obama",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/819YLKVUOhL._AC_UY218_.jpg",
    about:
      "Memoir of former First Lady Michelle Obama and her journey in life and public service.",
  },
  {
    key: 109,
    title: "Rich Dad's Cashflow Quadrant",
    language: "English",
    pages: 272,
    category: "Financial Education",
    price: 349,
    discount: 5,
    rating: 4.7,
    author: "Robert T. Kiyosaki",
    published_year: 1998,
    image_link:
      "https://m.media-amazon.com/images/I/61d-mamAxWL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      'A follow-up to "Rich Dad Poor Dad" that explains the different ways to generate income and build wealth.',
  },
  {
    key: 110,
    title: "Gut: The Inside Story of Our Body's Most Underrated Organ",
    language: "English",
    pages: 288,
    category: "Health",
    price: 1050,
    discount: 10,
    rating: 4.7,
    author: "Giulia Enders",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/71hiuc6C6eL._AC_UY218_.jpg",
    about:
      "Explores the role of the gut microbiome in our overall health and well-being.",
  },
  {
    key: 111,
    title: "Atomic Habits",
    language: "English",
    pages: 320,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.6,
    author: "James Clear",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/91bYsX41DVL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A practical guide to building good habits, breaking bad ones, and mastering small behaviors for significant results.",
  },
  {
    key: 112,
    title:
      "The Blue Zones: Lessons for Living Longer From the People Who've Lived the Longest",
    language: "English",
    pages: 336,
    category: "Health",
    price: 1150,
    discount: 10,
    rating: 4.6,
    author: "Dan Buettner",
    published_year: 2008,
    image_link:
      "https://m.media-amazon.com/images/I/81MbgACa6ZL._AC_UY218_.jpg",
    about:
      "Shares the lifestyle and diet habits of the world's longest-lived people.",
  },
  {
    key: 113,
    title: "The Millionaire Mind",
    language: "English",
    pages: 416,
    category: "Financial Education",
    price: 449,
    discount: 10,
    rating: 4.4,
    author: "Thomas J. Stanley",
    published_year: 2000,
    image_link:
      "https://m.media-amazon.com/images/I/81aapw8PNLL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A study of the mindset, attitudes, and characteristics of wealthy individuals.",
  },
  {
    key: 114,
    title: "Why We Sleep: Unlocking the Power of Sleep and Dreams",
    language: "English",
    pages: 360,
    category: "Health",
    price: 1250,
    discount: 15,
    rating: 4.8,
    author: "Matthew Walker",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/61JpthaQPUL._AC_UY218_.jpg",
    about:
      "Explores the importance of sleep for our physical and mental well-being.",
  },
  {
    key: 115,
    title: "The Subtle Art of Not Giving a F*ck",
    language: "English",
    pages: 224,
    category: "Financial Education",
    price: 249,
    discount: 10,
    rating: 4.4,
    author: "Mark Manson",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71t4GuxLCuL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A self-help book that challenges conventional wisdom and encourages living a more honest and meaningful life.",
  },
  {
    key: 116,
    title:
      "The Subtle Art of Not Giving a F*ck: A Counterintuitive Approach to Living a Good Life",
    language: "English",
    pages: 224,
    category: "Health",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Mark Manson",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71t4GuxLCuL._AC_UY218_.jpg",
    about:
      "Offers a fresh perspective on personal growth and finding meaning in life.",
  },
  {
    key: 117,
    title: "The Lean Startup",
    language: "English",
    pages: 336,
    category: "Financial Education",
    price: 399,
    discount: 8,
    rating: 4.5,
    author: "Eric Ries",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/81vvgZqCskL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A guide to building successful startups through the application of lean management and agile development principles.",
  },
  {
    key: 118,
    title: "The Girl with the Dragon Tattoo",
    language: "English",
    pages: 590,
    category: "Crime",
    price: 500,
    discount: 20,
    rating: 4.2,
    author: "Stieg Larsson",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/81YW99XIpJL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A gripping crime novel involving mystery and investigation.",
  },
  {
    key: 119,
    title: "And Then There Were None",
    language: "English",
    pages: 272,
    category: "Crime",
    price: 350,
    discount: 15,
    rating: 4.5,
    author: "Agatha Christie",
    published_year: 1939,
    image_link:
      "https://m.media-amazon.com/images/I/71HOUccJT6L._AC_UY327_FMwebp_QL65_.jpg",
    about: "Ten strangers on an isolated island are accused of murder.",
  },
  {
    key: 120,
    title: "Sacred Games",
    language: "English",
    pages: 1000,
    category: "Crime",
    price: 700,
    discount: 10,
    rating: 4.8,
    author: "Vikram Chandra",
    published_year: 2006,
    image_link:
      "https://m.media-amazon.com/images/I/91MCWisDhQL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A gripping tale of crime, corruption, and Mumbai underworld.",
  },
  {
    key: 121,
    title: "The Da Vinci Code",
    language: "English",
    pages: 454,
    category: "Crime",
    price: 450,
    discount: 5,
    rating: 4.3,
    author: "Dan Brown",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/81jtrIKJd2L._AC_UY327_FMwebp_QL65_.jpg",
    about: "A thrilling adventure involving symbology and secret societies.",
  },
  {
    key: 122,
    title: "Inferno",
    language: "English",
    pages: 480,
    category: "Crime",
    price: 400,
    discount: 10,
    rating: 4.1,
    author: "Dan Brown",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/71JVKXIBnbS._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Robert Langdon races to solve a deadly puzzle inspired by Dante's Inferno.",
  },
  {
    key: 123,
    title: "The Shining",
    language: "English",
    pages: 447,
    category: "Crime",
    price: 380,
    discount: 10,
    rating: 4.6,
    author: "Stephen King",
    published_year: 1977,
    image_link:
      "https://m.media-amazon.com/images/I/81zqohMOk-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A haunted hotel drives a writer to madness in this classic horror novel.",
  },
  {
    key: 124,
    title: "Gone Girl",
    language: "English",
    pages: 432,
    category: "Crime",
    price: 320,
    discount: 10,
    rating: 4.2,
    author: "Gillian Flynn",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/41aEQgTFPoL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A thrilling story of a missing wife and the dark secrets that unfold.",
  },
  {
    key: 125,
    title: "The Cuckoo's Calling",
    language: "English",
    pages: 449,
    category: "Crime",
    price: 300,
    discount: 10,
    rating: 4.0,
    author: "Robert Galbraith",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/813VeqK2TUL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Private detective Cormoran Strike investigates a supermodel's mysterious death.",
  },
  {
    key: 126,
    title: "The Godfather",
    language: "English",
    pages: 448,
    category: "Crime",
    price: 550,
    discount: 23,
    rating: 4.9,
    author: "Mario Puzo",
    published_year: 1969,
    image_link:
      "https://m.media-amazon.com/images/I/51YKBL08tJL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A gripping tale of power, family, and the Italian-American mafia.",
  },
  {
    key: 127,
    title: "The Hound of the Baskervilles",
    language: "English",
    pages: 190,
    category: "Crime",
    price: 200,
    discount: 0,
    rating: 4.4,
    author: "Arthur Conan Doyle",
    published_year: 1902,
    image_link:
      "https://m.media-amazon.com/images/I/81WlpQBRxhL._AC_UY218_.jpg",
    about:
      "Sherlock Holmes investigates the legend of a cursed family in the moors of England.",
  },
  {
    key: 128,
    title: "Murder on the Orient Express",
    language: "English",
    pages: 274,
    category: "Crime",
    price: 350,
    discount: 12,
    rating: 4.7,
    author: "Agatha Christie",
    published_year: 1934,
    image_link:
      "https://m.media-amazon.com/images/I/81YVXgvXoAL._AC_UY327_FMwebp_QL65_.jpg",
    about: "Hercule Poirot solves a murder aboard a luxurious train.",
  },
  {
    key: 129,
    title: "The Secret History",
    language: "English",
    pages: 559,
    category: "Crime",
    price: 450,
    discount: 5,
    rating: 4.3,
    author: "Donna Tartt",
    published_year: 1992,
    image_link:
      "https://m.media-amazon.com/images/I/81YhQfeiynL._AC_UY327_FMwebp_QL65_.jpg",
    about: "A group of college students and a murder that changes their lives.",
  },
  {
    key: 130,
    title: "Angels & Demons",
    language: "English",
    pages: 572,
    category: "Crime",
    price: 420,
    discount: 10,
    rating: 4.0,
    author: "Dan Brown",
    published_year: 2000,
    image_link:
      "https://m.media-amazon.com/images/I/71H1acpbGaL._AC_UY327_FMwebp_QL65_.jpghttps://m.media-amazon.com/images/I/71H1acpbGaL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Robert Langdon races against time to stop a dangerous secret society.",
  },
  {
    key: 131,
    title: "In Cold Blood",
    language: "English",
    pages: 343,
    category: "Crime",
    price: 380,
    discount: 15,
    rating: 4.5,
    author: "Truman Capote",
    published_year: 1966,
    image_link:
      "https://m.media-amazon.com/images/I/61iCPc5e5iL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A true crime novel based on the murder of the Clutter family in Kansas.",
  },
  {
    key: 132,
    title: "The Silence of the Lambs",
    language: "English",
    pages: 368,
    category: "Crime",
    price: 400,
    discount: 10,
    rating: 4.6,
    author: "Thomas Harris",
    published_year: 1988,
    image_link:
      "https://m.media-amazon.com/images/I/814fRILnbnL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "FBI trainee Clarice Starling seeks the help of the incarcerated Dr. Hannibal Lecter.",
  },
  {
    key: 133,
    title: "The Girl on the Train",
    language: "English",
    pages: 336,
    category: "Crime",
    price: 320,
    discount: 5,
    rating: 4.1,
    author: "Paula Hawkins",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/71ErsKpwmrS._AC_UY327_FMwebp_QL65_.jpg",
    about: "A woman becomes entangled in a missing person's investigation.",
  },
  {
    key: 134,
    title: "The Maltese Falcon",
    language: "English",
    pages: 217,
    category: "Crime",
    price: 250,
    discount: 0,
    rating: 4.4,
    author: "Dashiell Hammett",
    published_year: 1930,
    image_link:
      "https://m.media-amazon.com/images/I/91sLlpcMhOL._AC_UY327_FMwebp_QL65_.jpg",
    about: "Private detective Sam Spade searches for a valuable statuette.",
  },
  {
    key: 135,
    title: "The Snowman",
    language: "English",
    pages: 480,
    category: "Crime",
    price: 380,
    discount: 10,
    rating: 4.0,
    author: "Jo Nesbo",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/81Rv66kXRLL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Detective Harry Hole investigates a serial killer who builds snowmen at his crime scenes.",
  },
  {
    key: 136,
    title: "The Adventures of Sherlock Holmes",
    language: "English",
    pages: 307,
    category: "Crime",
    price: 300,
    discount: 5,
    rating: 4.8,
    author: "Arthur Conan Doyle",
    published_year: 1892,
    image_link:
      "https://m.media-amazon.com/images/I/81Twgv8OxbL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A collection of short stories featuring the famous detective Sherlock Holmes.",
  },
  {
    key: 137,
    title: "Dark Places",
    language: "English",
    pages: 349,
    category: "Crime",
    price: 320,
    discount: 10,
    rating: 4.2,
    author: "Gillian Flynn",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/71Wm30jjysL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Libby Day confronts the dark truth behind the murder of her family.",
  },
  {
    key: 138,
    title: "The Big Sleep",
    language: "English",
    pages: 231,
    category: "Crime",
    price: 250,
    discount: 10,
    rating: 4.3,
    author: "Raymond Chandler",
    published_year: 1939,
    image_link:
      "https://m.media-amazon.com/images/I/716toEqJ6jL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Private detective Philip Marlowe gets entangled in a web of blackmail and murder.",
  },
  {
    key: 139,
    title: "Red Dragon",
    language: "English",
    pages: 464,
    category: "Crime",
    price: 400,
    discount: 15,
    rating: 4.4,
    author: "Thomas Harris",
    published_year: 1981,
    image_link:
      "https://m.media-amazon.com/images/I/81dkf1dFePL._AC_UL600_FMwebp_QL65_.jpg",
    about:
      'FBI profiler Will Graham hunts a terrifying serial killer known as "The Tooth Fairy".',
  },
  {
    key: 140,
    title: "The Silence of the White City",
    language: "English",
    pages: 490,
    category: "Crime",
    price: 550,
    discount: 10,
    rating: 4.1,
    author: "Eva Garcia Saenz",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/91VLFTqR-aL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A serial killer resurfaces after 20 years, and a detective must stop him.",
  },
  {
    key: 141,
    title: "The Black Echo",
    language: "English",
    pages: 496,
    category: "Crime",
    price: 450,
    discount: 5,
    rating: 4.2,
    author: "Michael Connelly",
    published_year: 1992,
    image_link:
      "https://m.media-amazon.com/images/I/41QRO5S6CCS._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Detective Harry Bosch investigates a murder linked to his troubled past.",
  },
  {
    key: 142,
    title: "The No. 1 Ladies' Detective Agency",
    language: "English",
    pages: 235,
    category: "Crime",
    price: 350,
    discount: 10,
    rating: 4.0,
    author: "Alexander McCall Smith",
    published_year: 1998,
    image_link:
      "https://m.media-amazon.com/images/I/51jgw+cOTFL._AC_UY327_FMwebp_QL65_.jpg",
    about: "Precious Ramotswe opens her detective agency in Botswana.",
  },
  {
    key: 143,
    title: "The Talented Mr. Ripley",
    language: "English",
    pages: 384,
    category: "Crime",
    price: 400,
    discount: 5,
    rating: 4.3,
    author: "Patricia Highsmith",
    published_year: 1955,
    image_link:
      "https://m.media-amazon.com/images/I/81FTssYCIRL._AC_UY327_FMwebp_QL65_.jpg",
    about: "Tom Ripley becomes entangled in a web of deceit and murder.",
  },
  {
    key: 144,
    title: "The Alienist",
    language: "English",
    pages: 498,
    category: "Crime",
    price: 500,
    discount: 10,
    rating: 4.1,
    author: "Caleb Carr",
    published_year: 1994,
    image_link:
      "https://m.media-amazon.com/images/I/91eg2tnW58L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Dr. Laszlo Kreizler, a psychologist, tracks down a serial killer in 19th-century New York.",
  },
  {
    key: 145,
    title: "The Poet",
    language: "English",
    pages: 466,
    category: "Crime",
    price: 450,
    discount: 10,
    rating: 4.5,
    author: "Michael Connelly",
    published_year: 1996,
    image_link:
      "https://m.media-amazon.com/images/I/51HI3T9BmML._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Reporter Jack McEvoy investigates a serial killer who targets poets.",
  },
  {
    key: 146,
    title: "The Bat",
    language: "English",
    pages: 369,
    category: "Crime",
    price: 300,
    discount: 10,
    rating: 4.0,
    author: "Jo Nesbo",
    published_year: 1997,
    image_link:
      "https://th.bing.com/th/id/OIP.jRpUTzdtpiAQa2FZY6eiJQAAAA?pid=ImgDet&w=200&h=306&c=7&dpr=1.5",
    about: "Detective Harry Hole investigates a murder in Sydney, Australia.",
  },
  {
    key: 147,
    title: "The Neon Rain",
    language: "English",
    pages: 370,
    category: "Crime",
    price: 320,
    discount: 5,
    rating: 4.3,
    author: "James Lee Burke",
    published_year: 1987,
    image_link:
      "https://m.media-amazon.com/images/I/91jLLAGn3-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Detective Dave Robicheaux battles drug lords and corruption in New Orleans.",
  },
  {
    key: 148,
    title: "Sapiens: A Brief History of Humankind",
    language: "English",
    pages: 443,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.6,
    author: "Yuval Noah Harari",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/713jIoMO3UL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Tracing the history of Homo sapiens and the impact of social, economic, and technological changes on humanity.",
  },
  {
    key: 149,
    title: "Guns, Germs, and Steel: The Fates of Human Societies",
    language: "English",
    pages: 496,
    category: "History",
    price: 550,
    discount: 10,
    rating: 4.5,
    author: "Jared Diamond",
    published_year: 1997,
    image_link:
      "https://m.media-amazon.com/images/I/81RdveuYXWL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Investigating the factors that led to the rise of certain civilizations and the disparities in wealth and power.",
  },
  {
    key: 150,
    title: "A People's History of the United States",
    language: "English",
    pages: 729,
    category: "History",
    price: 800,
    discount: 15,
    rating: 4.6,
    author: "Howard Zinn",
    published_year: 1980,
    image_link:
      "https://m.media-amazon.com/images/I/81s0FnUkqIL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Presenting a different perspective on the history of the United States, highlighting the struggles of marginalized groups.",
  },
  {
    key: 151,
    title: "The Wright Brothers",
    language: "English",
    pages: 336,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.4,
    author: "David McCullough",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/81+O-3L5rYL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A detailed account of the lives and achievements of the Wright brothers in the field of aviation.",
  },
  {
    key: 152,
    title: "The Rise and Fall of the Third Reich",
    language: "English",
    pages: 1616,
    category: "History",
    price: 1200,
    discount: 10,
    rating: 4.7,
    author: "William L. Shirer",
    published_year: 1960,
    image_link:
      "https://m.media-amazon.com/images/I/81ciybXQ44L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An authoritative and comprehensive account of Nazi Germany from its rise to power to its downfall.",
  },
  {
    key: 153,
    title: "1491: New Revelations of the Americas Before Columbus",
    language: "English",
    pages: 541,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.3,
    author: "Charles C. Mann",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/812bCWhIkoL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Challenging the traditional narrative of the Americas before the arrival of Christopher Columbus.",
  },
  {
    key: 154,
    title:
      "The Devil in the White City: Murder, Magic, and Madness at the Fair That Changed America",
    language: "English",
    pages: 447,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.4,
    author: "Erik Larson",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/91+CGkC4bGL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Exploring the events surrounding the 1893 World's Fair in Chicago and the actions of serial killer H.H. Holmes.",
  },
  {
    key: 155,
    title:
      "The Crusades: The Authoritative History of the War for the Holy Land",
    language: "English",
    pages: 1184,
    category: "History",
    price: 1000,
    discount: 12,
    rating: 4.6,
    author: "Thomas Asbridge",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/71EpTF7CJPL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive account of the Crusades, exploring the political, religious, and cultural aspects of the conflict.",
  },
  {
    key: 156,
    title: "Sapiens: A Brief History of Humankind",
    language: "English",
    pages: 443,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.5,
    author: "Yuval Noah Harari",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/713jIoMO3UL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Tracing the history of Homo sapiens and the impact of social, economic, and technological changes on humanity.",
  },
  {
    key: 157,
    title: "The Emperor of All Maladies: A Biography of Cancer",
    language: "English",
    pages: 592,
    category: "History",
    price: 550,
    discount: 10,
    rating: 4.6,
    author: "Siddhartha Mukherjee",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/71sylz8QEaL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Tracing the history of cancer, from its first documented appearances to the present day.",
  },
  {
    key: 158,
    title: "The Silk Roads: A New History of the World",
    language: "English",
    pages: 672,
    category: "History",
    price: 700,
    discount: 12,
    rating: 4.7,
    author: "Peter Frankopan",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/A15++jTYXJL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examining the role of the Silk Roads in shaping global history and the exchange of goods, ideas, and cultures.",
  },
  {
    key: 159,
    title: "SPQR: A History of Ancient Rome",
    language: "English",
    pages: 608,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.5,
    author: "Mary Beard",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/91UOL+G08CL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An exploration of the history of ancient Rome, its politics, society, and cultural achievements.",
  },
  {
    key: 160,
    title: "The Guns of August",
    language: "English",
    pages: 640,
    category: "History",
    price: 650,
    discount: 10,
    rating: 4.5,
    author: "Barbara W. Tuchman",
    published_year: 1962,
    image_link:
      "https://m.media-amazon.com/images/I/91QS0lmbnvL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "An account of the events leading up to World War I, focusing on the crucial first month of the conflict.",
  },
  {
    key: 161,
    title:
      "The Warmth of Other Suns: The Epic Story of America's Great Migration",
    language: "English",
    pages: 640,
    category: "History",
    price: 650,
    discount: 10,
    rating: 4.6,
    author: "Isabel Wilkerson",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/A1qH7DZkEKL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Chronicles the migration of African Americans from the southern United States to the North and West.",
  },
  {
    key: 162,
    title: "The Rise and Fall of Ancient Egypt",
    language: "English",
    pages: 512,
    category: "History",
    price: 550,
    discount: 10,
    rating: 4.6,
    author: "Toby Wilkinson",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/51F2xp2ePNL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A comprehensive history of ancient Egypt, from its origins to its decline and fall.",
  },
  {
    key: 163,
    title: "The Better Angels of Our Nature: Why Violence Has Declined",
    language: "English",
    pages: 832,
    category: "History",
    price: 900,
    discount: 12,
    rating: 4.4,
    author: "Steven Pinker",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/81y+8dxxC5L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Argues that violence has decreased over time and explores the factors contributing to this decline.",
  },
  {
    key: 164,
    title: "The Plantagenets: The Warrior Kings and Queens Who Made England",
    language: "English",
    pages: 624,
    category: "History",
    price: 700,
    discount: 12,
    rating: 4.5,
    author: "Dan Jones",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/81gTkKOWjGL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the history of the Plantagenet dynasty and its impact on England.",
  },
  {
    key: 165,
    title: "The Making of the Atomic Bomb",
    language: "English",
    pages: 886,
    category: "History",
    price: 950,
    discount: 12,
    rating: 4.6,
    author: "Richard Rhodes",
    published_year: 1987,
    image_link:
      "https://m.media-amazon.com/images/I/61zpBlSix4L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Traces the history of the development of the atomic bomb and its consequences.",
  },
  {
    key: 166,
    title: "The Ottoman Empire: A Short History",
    language: "English",
    pages: 320,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.3,
    author: "Mehmet Fuat Köprülü",
    published_year: 2002,
    image_link:
      "https://m.media-amazon.com/images/I/81mboHx441L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise overview of the rise and fall of the Ottoman Empire.",
  },
  {
    key: 167,
    title: "The American Revolution: A History",
    language: "English",
    pages: 400,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.4,
    author: "Gordon S. Wood",
    published_year: 2002,
    image_link:
      "https://m.media-amazon.com/images/I/71GjtmOdP-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the political, social, and intellectual origins of the American Revolution.",
  },
  {
    key: 168,
    title:
      "The Great Influenza: The Story of the Deadliest Pandemic in History",
    language: "English",
    pages: 560,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.5,
    author: "John M. Barry",
    published_year: 2004,
    image_link:
      "https://m.media-amazon.com/images/I/511l53+0RdL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "A detailed account of the 1918 influenza pandemic and its impact on society and medicine.",
  },
  {
    key: 169,
    title: "The Romanovs: 1613-1918",
    language: "English",
    pages: 832,
    category: "History",
    price: 900,
    discount: 12,
    rating: 4.7,
    author: "Simon Sebag Montefiore",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/813f2kEQojL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Chronicles the history of the Romanov dynasty, from its founding to its tragic end in the Russian Revolution.",
  },
  {
    key: 170,
    title:
      "The Origins of Political Order: From Prehuman Times to the French Revolution",
    language: "English",
    pages: 608,
    category: "History",
    price: 650,
    discount: 10,
    rating: 4.6,
    author: "Francis Fukuyama",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/61eU6U+9wYL._AC_UL600_FMwebp_QL65_.jpg",
    about:
      "Explores the development of political institutions and the evolution of human societies.",
  },
  {
    key: 171,
    title: "The Second World War",
    language: "English",
    pages: 992,
    category: "History",
    price: 1100,
    discount: 12,
    rating: 4.5,
    author: "Antony Beevor",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/81oG26hBOYL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Offers a comprehensive account of World War II, encompassing both the Eastern and Western fronts.",
  },
  {
    key: 172,
    title: "The Spanish Civil War: A Very Short Introduction",
    language: "English",
    pages: 184,
    category: "History",
    price: 250,
    discount: 10,
    rating: 4.2,
    author: "Helen Graham",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/51DDGuUbieL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise introduction to the causes, course, and consequences of the Spanish Civil War.",
  },
  {
    key: 173,
    title: "1493: Uncovering the New World Columbus Created",
    language: "English",
    pages: 560,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.4,
    author: "Charles C. Mann",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/81v+zCDkN-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the global impact of the Columbian Exchange and the interconnectedness of different regions.",
  },
  {
    key: 174,
    title:
      "The History of the Ancient World: From the Earliest Accounts to the Fall of Rome",
    language: "English",
    pages: 754,
    category: "History",
    price: 800,
    discount: 15,
    rating: 4.6,
    author: "Susan Wise Bauer",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/71YcGWbSkkL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides an overview of ancient civilizations and their contributions to world history.",
  },
  {
    key: 175,
    title:
      "The Norman Conquest: The Battle of Hastings and the Fall of Anglo-Saxon England",
    language: "English",
    pages: 464,
    category: "History",
    price: 550,
    discount: 10,
    rating: 4.3,
    author: "Marc Morris",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/814joDE6vXL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the events leading up to the Norman Conquest of England in 1066 and its aftermath.",
  },
  {
    key: 176,
    title: "The Mongol Empire: A Very Short Introduction",
    language: "English",
    pages: 152,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.1,
    author: "Morris Rossabi",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/41fP01aK3qL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise overview of the rise and impact of the Mongol Empire under Genghis Khan and his successors.",
  },
  {
    key: 177,
    title: "The Cold War: A World History",
    language: "English",
    pages: 736,
    category: "History",
    price: 850,
    discount: 12,
    rating: 4.5,
    author: "Odd Arne Westad",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/A1XriMo2e1L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the global impact of the Cold War and its ideological, political, and military dimensions.",
  },
  {
    key: 178,
    title: "A Short History of Nearly Everything",
    language: "English",
    pages: 624,
    category: "History",
    price: 700,
    discount: 12,
    rating: 4.6,
    author: "Bill Bryson",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/81IFXnlXNKL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Presents a comprehensive overview of scientific knowledge and the history of scientific discoveries.",
  },
  {
    key: 179,
    title: "The Black Death: A Personal History",
    language: "English",
    pages: 304,
    category: "History",
    price: 350,
    discount: 10,
    rating: 4.4,
    author: "John Hatcher",
    published_year: 2008,
    image_link:
      "https://m.media-amazon.com/images/I/51KZbwpEaVL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the impact of the Black Death in Europe and its effects on society, culture, and individuals.",
  },
  {
    key: 180,
    title: "The Punic Wars",
    language: "English",
    pages: 384,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.3,
    author: "Adrian Goldsworthy",
    published_year: 2000,
    image_link:
      "https://m.media-amazon.com/images/I/61P7weyNLjL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the three wars fought between Rome and Carthage in the 3rd and 2nd centuries BCE.",
  },
  {
    key: 181,
    title: "The Crusades: A History",
    language: "English",
    pages: 560,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.5,
    author: "Thomas Asbridge",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/815fr6mqZqS._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a comprehensive account of the Crusades, exploring their causes, events, and legacies.",
  },
  {
    key: 182,
    title: "The Age of Revolution: 1789-1848",
    language: "English",
    pages: 768,
    category: "History",
    price: 800,
    discount: 15,
    rating: 4.6,
    author: "Eric Hobsbawm",
    published_year: 1962,
    image_link:
      "https://m.media-amazon.com/images/I/81rdT7z+BHL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the era of political and social revolutions that reshaped Europe and the world.",
  },
  {
    key: 183,
    title: "The Making of the West: Peoples and Cultures",
    language: "English",
    pages: 1080,
    category: "History",
    price: 1200,
    discount: 10,
    rating: 4.4,
    author:
      "Lynn Hunt, Thomas R. Martin, Barbara H. Rosenwein, Bonnie G. Smith",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/611cDu8SICL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the political, cultural, and social history of the Western world from ancient times to the present.",
  },
  {
    key: 184,
    title: "The Renaissance: A Short History",
    language: "English",
    pages: 240,
    category: "History",
    price: 300,
    discount: 10,
    rating: 4.3,
    author: "Paul Johnson",
    published_year: 2000,
    image_link:
      "https://m.media-amazon.com/images/I/61mZsCJO0kL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides an overview of the Renaissance, focusing on its cultural, artistic, and intellectual developments.",
  },
  {
    key: 185,
    title: "The Russian Revolution",
    language: "English",
    pages: 384,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.4,
    author: "Sheila Fitzpatrick",
    published_year: 1982,
    image_link:
      "https://m.media-amazon.com/images/I/81bSpfjpOEL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the events and consequences of the Russian Revolution of 1917.",
  },
  {
    key: 186,
    title: "The Holocaust: A New History",
    language: "English",
    pages: 992,
    category: "History",
    price: 1100,
    discount: 12,
    rating: 4.7,
    author: "Laurence Rees",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/91ow3sfIoAL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Offers a comprehensive account of the Holocaust, exploring its origins, implementation, and aftermath.",
  },
  {
    key: 187,
    title: "The French Revolution: A Very Short Introduction",
    language: "English",
    pages: 160,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.2,
    author: "William Doyle",
    published_year: 2001,
    image_link:
      "https://m.media-amazon.com/images/I/91nT4hh-pEL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise introduction to the French Revolution, its causes, events, and impact.",
  },
  {
    key: 188,
    title: "The Mongols: A Very Short Introduction",
    language: "English",
    pages: 160,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.1,
    author: "Morris Rossabi",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/41fP01aK3qL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Offers a concise overview of the history and impact of the Mongol Empire.",
  },
  {
    key: 189,
    title: "The Cold War: A History",
    language: "English",
    pages: 784,
    category: "History",
    price: 850,
    discount: 12,
    rating: 4.5,
    author: "John Lewis Gaddis",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/61ZRac2iSDL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides an in-depth analysis of the political, ideological, and military aspects of the Cold War.",
  },
  {
    key: 190,
    title:
      "The Birth of the West: Rome, Germany, France, and the Creation of Europe in the Tenth Century",
    language: "English",
    pages: 464,
    category: "History",
    price: 550,
    discount: 10,
    rating: 4.3,
    author: "Paul Collins",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/51Xqv3NFmDL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the cultural, political, and social developments in Western Europe during the tenth century.",
  },
  {
    key: 191,
    title: "The Norman Conquest: A Very Short Introduction",
    language: "English",
    pages: 144,
    category: "History",
    price: 180,
    discount: 10,
    rating: 4.1,
    author: "George Garnett",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/51DLUkMpUwL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise overview of the Norman Conquest of England in 1066 and its historical significance.",
  },
  {
    key: 192,
    title: "The Fall of the Roman Empire: A New History",
    language: "English",
    pages: 544,
    category: "History",
    price: 600,
    discount: 10,
    rating: 4.4,
    author: "Peter Heather",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/61B2BoA1XFL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Offers a fresh perspective on the decline and fall of the Roman Empire, exploring its political and cultural aspects.",
  },
  {
    key: 193,
    title:
      "The Age of Exploration: From Christopher Columbus to Ferdinand Magellan",
    language: "English",
    pages: 416,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.3,
    author: "Felipe Fernández-Armesto",
    published_year: 2007,
    image_link:
      "https://m.media-amazon.com/images/I/51Vkot9lfgL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the era of exploration and discovery, focusing on the key figures and their voyages.",
  },
  {
    key: 194,
    title: "The Tudors: A Very Short Introduction",
    language: "English",
    pages: 152,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.2,
    author: "John Guy",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/51wqy7kzjjL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise overview of the Tudor dynasty and its impact on England and Europe.",
  },
  {
    key: 195,
    title: "The Age of Extremes: A History of the World, 1914-1991",
    language: "English",
    pages: 832,
    category: "History",
    price: 900,
    discount: 12,
    rating: 4.6,
    author: "Eric Hobsbawm",
    published_year: 1994,
    image_link:
      "https://m.media-amazon.com/images/I/81Ns4+JY13L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the major political, social, and economic developments of the 20th century.",
  },
  {
    key: 196,
    title: "The Wars of the Roses",
    language: "English",
    pages: 416,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.5,
    author: "Alison Weir",
    published_year: 1995,
    image_link:
      "https://m.media-amazon.com/images/I/71Z+avnDDDL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides an in-depth account of the Wars of the Roses, a series of civil wars in England during the 15th century.",
  },
  {
    key: 197,
    title: "The Russian Revolution: A Very Short Introduction",
    language: "English",
    pages: 160,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.1,
    author: "S. A. Smith",
    published_year: 2002,
    image_link:
      "https://m.media-amazon.com/images/I/51YZ22YzgaL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Offers a concise introduction to the Russian Revolution, its causes, events, and impact.",
  },
  {
    key: 198,
    title:
      "The Worldly Philosophers: The Lives, Times, and Ideas of the Great Economic Thinkers",
    language: "English",
    pages: 368,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.3,
    author: "Robert L. Heilbroner",
    published_year: 1953,
    image_link:
      "https://m.media-amazon.com/images/I/51995NQKMPL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Profiles the major economic thinkers throughout history and their contributions to economic thought.",
  },
  {
    key: 199,
    title: "The Fall of Constantinople 1453",
    language: "English",
    pages: 224,
    category: "History",
    price: 300,
    discount: 10,
    rating: 4.2,
    author: "Steven Runciman",
    published_year: 1965,
    image_link:
      "https://m.media-amazon.com/images/I/5129bMGSwHL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Recounts the events leading up to the fall of Constantinople to the Ottoman Empire in 1453.",
  },
  {
    key: 200,
    title: "The Reformation: A Very Short Introduction",
    language: "English",
    pages: 160,
    category: "History",
    price: 200,
    discount: 10,
    rating: 4.1,
    author: "Peter Marshall",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/91k4HtQ3KKL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Provides a concise introduction to the Protestant Reformation and its impact on religious and social change.",
  },
  {
    key: 201,
    title: "Genghis Khan and the Making of the Modern World",
    language: "English",
    pages: 352,
    category: "History",
    price: 400,
    discount: 10,
    rating: 4.5,
    author: "Jack Weatherford",
    published_year: 2004,
    image_link:
      "https://m.media-amazon.com/images/I/91MrxdduTtL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the life and achievements of Genghis Khan and the impact of the Mongol Empire on world history.",
  },
  {
    key: 202,
    title: "A People's History of the United States",
    language: "English",
    pages: 784,
    category: "History",
    price: 900,
    discount: 12,
    rating: 4.6,
    author: "Howard Zinn",
    published_year: 1980,
    image_link:
      "https://m.media-amazon.com/images/I/81s0FnUkqIL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Presents a different perspective on U.S. history, focusing on the experiences and struggles of ordinary people.",
  },
  {
    key: 203,
    title: "The Electric Black",
    language: "English",
    pages: 340,
    category: "Horror",
    price: 1457,
    discount: 10,
    rating: 4.3,
    author: "Joseph Schmalke and Rich Woodall",
    published_year: 2021,
    image_link:
      "https://m.media-amazon.com/images/I/81AXeBZc8QL._AC_UY218_.jpg",
    about:
      "The Electric Black is a horror series set in an antique shop that travels through time and space delivering cursed objects to unsuspecting customers.!",
  },
  {
    key: 204,
    title: "The Dark Labyrinth",
    language: "English",
    pages: 320,
    category: "Horror",
    price: 450,
    discount: 10,
    rating: 4.2,
    author: "A. S. Arnett ",
    published_year: 2022,
    image_link:
      "https://m.media-amazon.com/images/I/81BtFljydkL._AC_UY218_.jpg",
    about:
      "Navigate through the dark labyrinth and confront the terrors that lie within its depths.",
  },
  {
    key: 205,
    title: "The War of 1812: A Forgotten Conflict",
    language: "English",
    pages: 384,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.3,
    author: "Donald R. Hickey",
    published_year: 1989,
    image_link:
      "https://m.media-amazon.com/images/I/41cd0h3MS4L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the causes, events, and outcomes of the War of 1812 between the United States and Britain.",
  },
  {
    key: 206,
    title: "Haunting Dreams",
    language: "English",
    pages: 350,
    category: "Horror",
    price: 500,
    discount: 15,
    rating: 4.4,
    author: "Jan Christensen",
    published_year: 2021,
    image_link:
      "https://m.media-amazon.com/images/I/61ECfRuPe-L._AC_UY218_.jpg",
    about:
      "Enter the realm of haunting dreams where reality and nightmares collide.",
  },
  {
    key: 207,
    title: "The Age of Capital: 1848-1875",
    language: "English",
    pages: 576,
    category: "History",
    price: 650,
    discount: 10,
    rating: 4.5,
    author: "Eric Hobsbawm",
    published_year: 1975,
    image_link:
      "https://m.media-amazon.com/images/I/81Ev4HYS0-L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the economic, social, and political changes of the mid-19th century and the rise of capitalism.",
  },
  {
    key: 208,
    title: "The Forbidden Manuscript",
    language: "English",
    pages: 300,
    category: "Horror",
    price: 450,
    discount: 10,
    rating: 4.2,
    author: "Sophie Thompson",
    published_year: 2022,
    image_link:
      "https://m.media-amazon.com/images/I/71D0p0atqXL._AC_UY218_.jpg",
    about:
      "Unearth the forbidden manuscript that holds the key to ancient and unspeakable horrors.",
  },
  {
    key: 209,
    title: "The Age of Empire: 1875-1914",
    language: "English",
    pages: 416,
    category: "History",
    price: 450,
    discount: 10,
    rating: 4.4,
    author: "Eric Hobsbawm",
    published_year: 1987,
    image_link:
      "https://m.media-amazon.com/images/I/61dlLf-4WIL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Explores the global expansion of European empires and the major political and cultural developments of the time.",
  },
  {
    key: 210,
    title: "The Third Reich in Power: 1933-1939",
    language: "English",
    pages: 960,
    category: "History",
    price: 1000,
    discount: 15,
    rating: 4.6,
    author: "Richard J. Evans",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/71o2+13Wf3L._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the consolidation of power by the Nazi regime in Germany and its policies leading up to World War II.",
  },
  {
    key: 211,
    title: "The Age of Revolution: Europe 1789-1848",
    language: "English",
    pages: 736,
    category: "History",
    price: 800,
    discount: 12,
    rating: 4.5,
    author: "Eric Hobsbawm",
    published_year: 1962,
    image_link:
      "https://m.media-amazon.com/images/I/81rdT7z+BHL._AC_UY327_FMwebp_QL65_.jpg",
    about:
      "Examines the major political, social, and economic changes in Europe during the period of revolution.",
  },
  {
    key: 212,
    title: "The Pragmatic Programmer: Your Journey to Mastery",
    language: "English",
    pages: 352,
    category: "Programming",
    price: 950,
    discount: 15,
    rating: 4.8,
    author: "Andrew Hunt, David Thomas",
    published_year: 1999,
    image_link:
      "https://m.media-amazon.com/images/I/51yaxPX4BFL._AC_UY218_.jpg",
    about: "Practical advice to improve software development skills.",
  },
  {
    key: 213,
    title: "Design Patterns: Elements of Reusable Object-Oriented Software",
    language: "English",
    pages: 395,
    category: "Programming",
    price: 1450,
    discount: 20,
    rating: 4.7,
    author: "Erich Gamma, Richard Helm, Ralph Johnson, John Vlissides",
    published_year: 1994,
    image_link:
      "https://m.media-amazon.com/images/I/51JYkEpbhzL._AC_UY218_.jpg",
    about: "Classic book introducing reusable object-oriented design patterns.",
  },
  {
    key: 214,
    title: "Code Complete: A Practical Handbook of Software Construction",
    language: "English",
    pages: 960,
    category: "Programming",
    price: 1850,
    discount: 10,
    rating: 4.5,
    author: "Steve McConnell",
    published_year: 1993,
    image_link:
      "https://m.media-amazon.com/images/I/71CjT0N23ML._AC_UY218_.jpg",
    about:
      "Comprehensive guide to software construction techniques and best practices.",
  },
  {
    key: 215,
    title: "Introduction to Algorithms",
    language: "English",
    pages: 1312,
    category: "Programming",
    price: 2400,
    discount: 5,
    rating: 4.9,
    author:
      "Thomas H. Cormen, Charles E. Leiserson, Ronald L. Rivest, Clifford Stein",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/51U7VqFciNL._AC_UY218_.jpg",
    about: "Comprehensive textbook on algorithms and data structures.",
  },
  {
    key: 216,
    title: "Refactoring: Improving the Design of Existing Code",
    language: "English",
    pages: 464,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.8,
    author: "Martin Fowler",
    published_year: 1999,
    image_link:
      "https://m.media-amazon.com/images/I/81ezCJTXFKL._AC_UY218_.jpg",
    about:
      "Guide to refactoring techniques for improving code maintainability and readability.",
  },
  {
    key: 217,
    title: "JavaScript: The Good Parts",
    language: "English",
    pages: 176,
    category: "Programming",
    price: 750,
    discount: 10,
    rating: 4.5,
    author: "Douglas Crockford",
    published_year: 2008,
    image_link:
      "https://m.media-amazon.com/images/I/81kqrwS1nNL._AC_UY218_.jpg",
    about:
      "Explains the good parts of JavaScript and common pitfalls to avoid.",
  },
  {
    key: 218,
    title: "Head First Design Patterns",
    language: "English",
    pages: 694,
    category: "Programming",
    price: 1650,
    discount: 15,
    rating: 4.7,
    author: "Eric Freeman, Elisabeth Robson, Bert Bates, Kathy Sierra",
    published_year: 2004,
    image_link:
      "https://m.media-amazon.com/images/I/91bobQSPQrL._AC_UY218_.jpg",
    about:
      "Uses a visually rich format to teach design patterns and object-oriented concepts.",
  },
  {
    key: 219,
    title: "Cracking the Coding Interview",
    language: "English",
    pages: 687,
    category: "Programming",
    price: 1350,
    discount: 20,
    rating: 4.6,
    author: "Gayle Laakmann McDowell",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/61mIq2iJUXL._AC_UY218_.jpg",
    about:
      "Comprehensive guide to coding interviews, covering algorithmic problem-solving and interview strategies.",
  },
  {
    key: 220,
    title: "Python Crash Course",
    language: "English",
    pages: 544,
    category: "Programming",
    price: 950,
    discount: 10,
    rating: 4.8,
    author: "Eric Matthes",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/81py-nCTfrL._AC_UY218_.jpg",
    about: "Hands-on introduction to Python programming for beginners.",
  },
  {
    key: 221,
    title: "The Algorithm Design Manual",
    language: "English",
    pages: 738,
    category: "Programming",
    price: 1750,
    discount: 10,
    rating: 4.7,
    author: "Steven S. Skiena",
    published_year: 1997,
    image_link:
      "https://m.media-amazon.com/images/I/61S3b3bGCtL._AC_UY218_.jpg",
    about: "Comprehensive guide to algorithm design and analysis techniques.",
  },
  {
    key: 222,
    title: "Eloquent JavaScript: A Modern Introduction to Programming",
    language: "English",
    pages: 472,
    category: "Programming",
    price: 1250,
    discount: 15,
    rating: 4.6,
    author: "Marijn Haverbeke",
    published_year: 2011,
    image_link:
      "https://m.media-amazon.com/images/I/5138YhQZILL._AC_UY218_.jpg",
    about: "Introduces JavaScript programming concepts and best practices.",
  },
  {
    key: 223,
    title:
      "The Clean Architecture: A Craftsman's Guide to Software Structure and Design",
    language: "English",
    pages: 432,
    category: "Programming",
    price: 1450,
    discount: 10,
    rating: 4.9,
    author: "Robert C. Martin",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/41-sN-mzwKL._AC_UY218_.jpg",
    about:
      "Explains how to design modular, maintainable, and scalable software architectures.",
  },
  {
    key: 224,
    title: "Refactoring to Patterns",
    language: "English",
    pages: 512,
    category: "Programming",
    price: 1550,
    discount: 15,
    rating: 4.7,
    author: "Joshua Kerievsky",
    published_year: 2004,
    image_link:
      "https://m.media-amazon.com/images/I/71CcLsUvplL._AC_UY218_.jpg",
    about:
      "Combines refactoring techniques with design patterns to improve code quality.",
  },
  {
    key: 225,
    title: "The Mythical Man-Month: Essays on Software Engineering",
    language: "English",
    pages: 322,
    category: "Programming",
    price: 1050,
    discount: 10,
    rating: 4.6,
    author: "Frederick P. Brooks Jr.",
    published_year: 1975,
    image_link:
      "https://m.media-amazon.com/images/I/41g8JFCPzjL._AC_UY218_.jpg",
    about:
      "Classic essays on software project management and team coordination.",
  },
  {
    key: 226,
    title: "Domain-Driven Design: Tackling Complexity in the Heart of Software",
    language: "English",
    pages: 560,
    category: "Programming",
    price: 1650,
    discount: 20,
    rating: 4.8,
    author: "Eric Evans",
    published_year: 2003,
    image_link:
      "https://m.media-amazon.com/images/I/61aFldsgAmL._AC_UY218_.jpg",
    about:
      "Introduces a systematic approach to designing software using domain-driven techniques.",
  },
  {
    key: 227,
    title: "Structure and Interpretation of Computer Programs",
    language: "English",
    pages: 657,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.9,
    author: "Harold Abelson, Gerald Jay Sussman, Julie Sussman",
    published_year: 1984,
    image_link:
      "https://m.media-amazon.com/images/I/71noXgc3kgL._AC_UY218_.jpg",
    about:
      "Explores fundamental principles of computer programming and computational processes.",
  },
  {
    key: 228,
    title:
      "Cracking Codes with Python: An Introduction to Building and Breaking Ciphers",
    language: "English",
    pages: 416,
    category: "Programming",
    price: 950,
    discount: 10,
    rating: 4.7,
    author: "Al Sweigart",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/81KOL4RYF6L._AC_UY218_.jpg",
    about:
      "Teaches the basics of cryptography through hands-on programming exercises.",
  },
  {
    key: 229,
    title: "Programming Pearls",
    language: "English",
    pages: 256,
    category: "Programming",
    price: 850,
    discount: 10,
    rating: 4.5,
    author: "Jon Bentley",
    published_year: 1986,
    image_link:
      "https://m.media-amazon.com/images/I/4149RF10H4L._AC_UY218_.jpg",
    about:
      "Presents real-world programming challenges and efficient solutions.",
  },
  {
    key: 230,
    title: "The C Programming Language",
    language: "English",
    pages: 272,
    category: "Programming",
    price: 750,
    discount: 15,
    rating: 4.6,
    author: "Brian W. Kernighan, Dennis M. Ritchie",
    published_year: 1978,
    image_link:
      "https://m.media-amazon.com/images/I/81WfBL3mCEL._AC_UY218_.jpg",
    about: "Classic book on the C programming language and its usage.",
  },
  {
    key: 231,
    title: "Test-Driven Development: By Example",
    language: "English",
    pages: 240,
    category: "Programming",
    price: 1050,
    discount: 10,
    rating: 4.8,
    author: "Kent Beck",
    published_year: 2002,
    image_link:
      "https://m.media-amazon.com/images/I/51GGLEZlGqL._AC_UY218_.jpg",
    about:
      "Introduces the concept of test-driven development through practical examples.",
  },
  {
    key: 232,
    title: "Artificial Intelligence: A Modern Approach",
    language: "English",
    pages: 1152,
    category: "Programming",
    price: 2050,
    discount: 10,
    rating: 4.7,
    author: "Stuart Russell, Peter Norvig",
    published_year: 1995,
    image_link:
      "https://m.media-amazon.com/images/I/517eliFnOHL._AC_UY218_.jpg",
    about: "Covers the foundations and techniques of artificial intelligence.",
  },
  {
    key: 233,
    title: "Pro Git",
    language: "English",
    pages: 504,
    category: "Programming",
    price: 1250,
    discount: 15,
    rating: 4.6,
    author: "Scott Chacon, Ben Straub",
    published_year: 2014,
    image_link:
      "https://m.media-amazon.com/images/I/71HO8p7RaYL._AC_UY218_.jpg",
    about: "Comprehensive guide to Git version control system and workflows.",
  },
  {
    key: 234,
    title:
      "The Linux Programming Interface: A Linux and UNIX System Programming Handbook",
    language: "English",
    pages: 1552,
    category: "Programming",
    price: 2250,
    discount: 20,
    rating: 4.9,
    author: "Michael Kerrisk",
    published_year: 2010,
    image_link:
      "https://m.media-amazon.com/images/I/71ANvp6Tk4L._AC_UY218_.jpg",
    about: "In-depth guide to Linux system programming and API usage.",
  },
  {
    key: 235,
    title:
      "Clean Architecture: A Craftsman's Guide to Software Structure and Design",
    language: "English",
    pages: 432,
    category: "Programming",
    price: 1450,
    discount: 10,
    rating: 4.7,
    author: "Robert C. Martin",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/41-sN-mzwKL._AC_UY218_.jpg",
    about:
      "Principles and practices for designing clean and maintainable software architectures.",
  },
  {
    key: 236,
    title: "Learn Python the Hard Way",
    language: "English",
    pages: 320,
    category: "Programming",
    price: 950,
    discount: 15,
    rating: 4.5,
    author: "Zed A. Shaw",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/71IbWW0CtcL._AC_UY218_.jpg",
    about:
      "Teaches Python programming through a series of practical exercises.",
  },
  {
    key: 237,
    title: "Concurrency in Go: Tools and Techniques for Developers",
    language: "English",
    pages: 294,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.8,
    author: "Katherine Cox-Buday",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/71Em6oDlE9L._AC_UY218_.jpg",
    about:
      "Explains Go's concurrency features and best practices for writing concurrent programs.",
  },
  {
    key: 238,
    title: "Learning React: Functional Web Development with React and Redux",
    language: "English",
    pages: 350,
    category: "Programming",
    price: 1250,
    discount: 10,
    rating: 4.7,
    author: "Alex Banks, Eve Porcello",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/91gJrDrQuCL._AC_UY218_.jpg",
    about: "Introduces React and Redux for building modern web applications.",
  },
  {
    key: 239,
    title: "Operating System Concepts",
    language: "English",
    pages: 976,
    category: "Programming",
    price: 1850,
    discount: 15,
    rating: 4.6,
    author: "Abraham Silberschatz, Peter B. Galvin, Greg Gagne",
    published_year: 1990,
    image_link:
      "https://m.media-amazon.com/images/I/815oae4uF+L._AC_UY218_.jpg",
    about:
      "Covers the fundamental concepts and principles of operating systems.",
  },
  {
    key: 240,
    title: "Programming Language Pragmatics",
    language: "English",
    pages: 992,
    category: "Programming",
    price: 1750,
    discount: 10,
    rating: 4.8,
    author: "Michael L. Scott",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/515HJzXg5QL._AC_UY218_.jpg",
    about: "Discusses the design and implementation of programming languages.",
  },
  {
    key: 241,
    title: "Deep Learning",
    language: "English",
    pages: 800,
    category: "Programming",
    price: 2050,
    discount: 10,
    rating: 4.7,
    author: "Ian Goodfellow, Yoshua Bengio, Aaron Courville",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/A1GbblX7rOL._AC_UY218_.jpg",
    about:
      "Covers the theory and applications of deep learning algorithms and models.",
  },
  {
    key: 242,
    title: "The Ruby Programming Language",
    language: "English",
    pages: 448,
    category: "Programming",
    price: 1050,
    discount: 10,
    rating: 4.6,
    author: "David Flanagan, Yukihiro Matsumoto",
    published_year: 2008,
    image_link: "https://example.com/ruby_programming_language.jpg",
    about:
      "Comprehensive guide to the Ruby programming language and its ecosystem.",
  },
  {
    key: 243,
    title: "Effective Java",
    language: "English",
    pages: 416,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.9,
    author: "Joshua Bloch",
    published_year: 2008,
    image_link: "https://example.com/effective_java.jpg",
    about: "Provides best practices and tips for writing effective Java code.",
  },
  {
    key: 244,
    title: "Data Structures and Algorithms in Python",
    language: "English",
    pages: 748,
    category: "Programming",
    price: 1550,
    discount: 20,
    rating: 4.7,
    author: "Michael T. Goodrich, Roberto Tamassia, Michael H. Goldwasser",
    published_year: 2013,
    image_link: "https://example.com/ds_algorithms_python.jpg",
    about:
      "Covers data structures and algorithms using Python programming language.",
  },
  {
    key: 245,
    title: "Learning SQL",
    language: "English",
    pages: 386,
    category: "Programming",
    price: 950,
    discount: 10,
    rating: 4.8,
    author: "Alan Beaulieu",
    published_year: 2009,
    image_link: "https://example.com/learning_sql.jpg",
    about:
      "Introduction to SQL programming for managing and manipulating relational databases.",
  },
  {
    key: 246,
    title: "Mastering Regular Expressions",
    language: "English",
    pages: 544,
    category: "Programming",
    price: 1150,
    discount: 10,
    rating: 4.7,
    author: "Jeffrey E. F. Friedl",
    published_year: 2006,
    image_link:
      "https://m.media-amazon.com/images/I/71GDwaqtl5L._AC_UY218_.jpg",
    about:
      "Comprehensive guide to understanding and using regular expressions.",
  },
  {
    key: 247,
    title: "Pro ASP.NET Core MVC 2",
    language: "English",
    pages: 1017,
    category: "Programming",
    price: 1950,
    discount: 15,
    rating: 4.8,
    author: "Adam Freeman",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/61G7oiaQWKL._AC_UY218_.jpg",
    about:
      "In-depth guide to building web applications using ASP.NET Core MVC framework.",
  },
  {
    key: 248,
    title: "Practical Electronics for Inventors",
    language: "English",
    pages: 1056,
    category: "Programming",
    price: 1750,
    discount: 20,
    rating: 4.6,
    author: "Paul Scherz, Simon Monk",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/611a-HQvgVL._AC_UY218_.jpg",
    about:
      "Covers the fundamentals of electronics and practical applications for inventors.",
  },
  {
    key: 249,
    title: "Scala for the Impatient",
    language: "English",
    pages: 384,
    category: "Programming",
    price: 1250,
    discount: 15,
    rating: 4.7,
    author: "Cay S. Horstmann",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/917Y4fm4XlL._AC_UY218_.jpg",
    about:
      "Introduces the Scala programming language for experienced developers.",
  },
  {
    key: 250,
    title: "Learning Perl",
    language: "English",
    pages: 394,
    category: "Programming",
    price: 850,
    discount: 10,
    rating: 4.5,
    author: "Randal L. Schwartz, brian d foy, Tom Phoenix",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71KTO+rGd+L._AC_UY218_.jpg",
    about: "Beginner's guide to Perl programming language.",
  },
  {
    key: 251,
    title: "Pro Angular 6",
    language: "English",
    pages: 776,
    category: "Programming",
    price: 1450,
    discount: 10,
    rating: 4.7,
    author: "Adam Freeman",
    published_year: 2018,
    image_link:
      "https://m.media-amazon.com/images/I/61LFMa-SuEL._AC_UY218_.jpg",
    about:
      "Comprehensive guide to building web applications with Angular framework.",
  },
  {
    key: 252,
    title:
      "The Elements of Computing Systems: Building a Modern Computer from First Principles",
    language: "English",
    pages: 344,
    category: "Programming",
    price: 1050,
    discount: 10,
    rating: 4.6,
    author: "Noam Nisan, Shimon Schocken",
    published_year: 2005,
    image_link:
      "https://m.media-amazon.com/images/I/71AirYHis9L._AC_UY218_.jpg",
    about:
      "Teaches the basic principles of computer systems through building a complete computer from scratch.",
  },
  {
    key: 253,
    title: "Go in Action",
    language: "English",
    pages: 384,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.8,
    author: "William Kennedy, Brian Ketelsen, Erik St. Martin",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/71wG3uhjbEL._AC_UY218_.jpg",
    about:
      "Comprehensive guide to the Go programming language with real-world examples.",
  },
  {
    key: 254,
    title:
      "Pro Spring 5: An In-Depth Guide to the Spring Framework and Its Tools",
    language: "English",
    pages: 848,
    category: "Programming",
    price: 1550,
    discount: 20,
    rating: 4.7,
    author: "Iuliana Cosmina, Rob Harrop, Chris Schaefer, Clarence Ho",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/61VLfTf8rmL._AC_UY218_.jpg",
    about:
      "Comprehensive guide to the Spring framework for building Java applications.",
  },
  {
    key: 255,
    title: "Effective Python: 59 Specific Ways to Write Better Python",
    language: "English",
    pages: 256,
    category: "Programming",
    price: 950,
    discount: 10,
    rating: 4.8,
    author: "Brett Slatkin",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/41lsrnzyUnL._AC_UY218_.jpg",
    about:
      "Provides practical tips and techniques to write idiomatic and efficient Python code.",
  },
  {
    key: 256,
    title: "Data Science for Business",
    language: "English",
    pages: 414,
    category: "Programming",
    price: 1150,
    discount: 10,
    rating: 4.6,
    author: "Foster Provost, Tom Fawcett",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/71sExM98TWL._AC_UY218_.jpg",
    about:
      "Introduces the concepts and applications of data science in business.",
  },
  {
    key: 257,
    title: "Raspberry Pi Cookbook",
    language: "English",
    pages: 510,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Simon Monk",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71hSo22CHIL._AC_UY218_.jpg",
    about:
      "Offers practical recipes and projects for Raspberry Pi enthusiasts.",
  },
  {
    key: 258,
    title: "Dive into Deep Learning",
    language: "English",
    pages: 437,
    category: "Programming",
    price: 1250,
    discount: 10,
    rating: 4.8,
    author: "Aston Zhang, Zachary C. Lipton, Mu Li, Alexander J. Smola",
    published_year: 2019,
    image_link:
      "https://m.media-amazon.com/images/I/61FQRLgJsrL._AC_UY218_.jpg",
    about:
      "Covers deep learning theory and practice with interactive Jupyter notebooks.",
  },
  {
    key: 259,
    title: "Building Microservices",
    language: "English",
    pages: 280,
    category: "Programming",
    price: 1050,
    discount: 10,
    rating: 4.6,
    author: "Sam Newman",
    published_year: 2015,
    image_link:
      "https://m.media-amazon.com/images/I/71QrFo8N3tL._AC_UY218_.jpg",
    about:
      "Provides guidance on designing, deploying, and maintaining microservices-based systems.",
  },

  {
    key: 260,
    title: "Effective DevOps",
    language: "English",
    pages: 400,
    category: "Programming",
    price: 1350,
    discount: 15,
    rating: 4.7,
    author: "Jennifer Davis, Katherine Daniels, Ryn Daniels",
    published_year: 2016,
    image_link:
      "https://m.media-amazon.com/images/I/71nj1bN3UaL._AC_UY218_.jpg",
    about:
      "Offers practical advice and best practices for implementing DevOps in organizations.",
  },
  {
    key: 261,
    title: "Learning Docker",
    language: "English",
    pages: 384,
    category: "Programming",
    price: 1250,
    discount: 10,
    rating: 4.8,
    author: "Pethuru Raj, Jeeva S. Chelladhurai, Vinod Singh",
    published_year: 2017,
    image_link:
      "https://m.media-amazon.com/images/I/614HXVgj4OL._AC_UY218_.jpg",
    about:
      "Introduces Docker and containerization concepts with hands-on examples.",
  },
  {
    key: 262,
    title: "Natural Language Processing with Python",
    language: "English",
    pages: 504,
    category: "Programming",
    price: 1450,
    discount: 10,
    rating: 4.7,
    author: "Steven Bird, Ewan Klein, Edward Loper",
    published_year: 2009,
    image_link:
      "https://m.media-amazon.com/images/I/71k+ioM5i9L._AC_UY218_.jpg",
    about:
      "Provides an introduction to natural language processing using the Python programming language.",
  },
  {
    key: 263,
    title: "Practical Object-Oriented Design in Ruby",
    language: "English",
    pages: 430,
    category: "Programming",
    price: 1250,
    discount: 15,
    rating: 4.7,
    author: "Sandi Metz",
    published_year: 2012,
    image_link:
      "https://m.media-amazon.com/images/I/61qpmhZRxGL._AC_UY218_.jpg",
    about:
      "Offers practical advice for designing object-oriented Ruby applications.",
  },
  {
    key: 264,
    title:
      "Effective JavaScript: 68 Specific Ways to Harness the Power of JavaScript",
    language: "English",
    pages: 240,
    category: "Programming",
    price: 950,
    discount: 10,
    rating: 4.6,
    author: "David Herman",
    published_year: 2013,
    image_link:
      "https://m.media-amazon.com/images/I/416VUkOt3QL._AC_UY218_.jpg",
    about:
      "Provides tips and techniques for writing effective and idiomatic JavaScript code.",
  },
  {
    key: 265,
    title: "The Art of Computer Programming",
    language: "English",
    pages: 3168,
    category: "Programming",
    price: 2950,
    discount: 20,
    rating: 4.9,
    author: "Donald E. Knuth",
    published_year: 1968,
    image_link:
      "https://m.media-amazon.com/images/I/81wtSv5ttKL._AC_UY218_.jpg",
    about:
      "Classic multi-volume work on computer programming algorithms and principles.",
  },
];

export default books;
